import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const defaultNS = 'translation';
export const fallbackNS = 'translation';

const fallbackTranslations = {
  en: {
    fallback: 'Not found',
  },
  // You can add more fallback translations for other languages here
};

const options = {
  resources: {
    /* English translations */
    en: {
      translation: {
        a11y: {
          skipToMainContent: 'Skip to main content',
        },
        fieldValue: {
          complexObject: 'Complex data (object)',
          unnamedFile: 'Unnamed file',
          fileCount_one: '{{count}} file',
          fileCount_other: '{{count}} files',
        },
        auth: {
          login: 'Log in',
          findOut: 'Find out more to register',
          participantLogin: 'Participant log in',
          adminLogin: 'Admin Log in',
          psrLogin: 'PSR Log in',
          adminMgrLogin: 'Admin Manager Log in',
          sysAdminLogin: 'System Admin Log in',
          contractorLogin: 'Contractor login',
          sysAdmin: {
            createTitle: 'Create system admin account',
            loginTitle: 'System admin log in',
          },
          adminAccountAccess: 'If you cannot login with your IDIR, please contact your administrator to gain access.',
          adminPortalLoginInfo: {
            prompt: '',
            login: 'You must authenticate with an IDIR account to use this system.',
            button: 'Log in with IDIR account',
            trouble: {
              beforeLink: 'IDIR users who have registered for MFA may reset their password via ',
              linkText: 'Self Service Password Reset',
              afterLink:
                '\n\nIf you are not MFA registered, or require additional assistance, please contact your IDIR security administrator or the OCIO IT Service Desk at:\nPhone: 250-387-7000\nEmail: 77000@gov.bc.ca',
              link: 'https://passwordreset.microsoftonline.com/',
            },
            noAccount: {
              text: 'Don’t have an IDIR account?',
              altLoginText: 'Log in with Business BCeID',
            },
          },
          footer:
            'Your personal information is collected under section 26(c) of the Freedom of Information and Protection of Privacy Act for the purpose of applying to the Better Homes Energy Savings Program. The Energy Savings Program is administered by the Ministry of Energy and Climate Solutions. If you have any questions about the collection of your information, please contact program administrators at ',
          betterHomesEmail: 'betterhomesbc@gov.bc.ca',
          period: '.',
          bcServiceCardInfo: {
            bcservice_login: 'Log in with BC Services Card Account',
            prompt:
              'The easiest way to log in is with your BC Services Card. It’s a secure way to prove who you are online. ',
            learnMore: 'Learn more about BC Services Card',
            learnMoreLink: 'https://id.gov.bc.ca/account/',
            loginHelp: 'and how to set up an account.',
            noSmartPhone: 'Don’t have a smartphone or don’t want to use the mobile app?',
            noBCServicesCard: 'Don’t have a BC Services Card?',
            phoneService: 'You can use the BC Token. They are free and you can pick one up at any Service BC office.',
            bceidLogin: 'Log in with Basic BCeID',
            serviceCardTokens: 'Learn more about BC Tokens.',
            learnMoreTokensLink: 'https://id.gov.bc.ca/account/token-setup-instruction',
            energyCoach: {
              phoneNumber: '1-833-856-0333',
              phoneNumberHours: '9 am - 5 pm, Monday to Friday (excluding statutory holidays)',
              title: 'We can help with:',
              description: 'Request a call with an Energy coach for assistance with:',
              fillingRebate: 'Filling in your application',
              rebateQuestions: 'Questions about rebate programs and upgrades',
              virtualWalkThrough: 'A virtual walk-through of your home',
              homeUpgrades: 'Home upgrade opportunities in general',
              requestACall: 'Book a call',
              ctaLink: 'https://www.betterbuildingsbc.ca/connect/',
            },
          },
          bceidInfo: {
            heading: 'Which BCeID should I use?',
            needHelp: 'Need help with your application?',
            contactCoach: 'Contact an energy coach',
            // basic: {
            //   title: "Basic BCeID",
            //   description: "Use when accessing a service in a personal capacity.",
            //   homeownerAgent: "homeowner, agent",
            //   architectContractor: "architect or contractor may use Basic BCeID or Business BCeID",
            //   register: "Register for Basic BCeID",
            // },
            // business: {
            //   title: "Business BCeID",
            //   description: "Use when representing a legal entity, such as a:",
            //   localGov: "Local government(s) or local jurisdiction(s)",
            //   company: "Company or partnership or sole proprietorship",
            //   nonProfit: "Not-for-profit or charitable organization",
            //   education: "Educational institution like a university or college",
            //   seeMore: "See more details",
            //   register: "Register for Business BCeID",
            // },
            contractor: {
              loginPrompt: 'You must log in with a Business BCeID account.',
              loginButton: 'Log in with Business BCeID Account',
              needSetup: 'Do you need to set up your Business BCeID account? Get started',
              here: 'here',
            },
          },
          noAccount: 'Don’t have an account?',
          logout: 'Logout',
          submit: 'Submit',
          or: 'or',
          bceid_login: 'Log in with BCeID',
          bcsc_login: 'Log in with BC Services Card Account',
          idir_login: 'Log in with IDIR',
          troubleLogging: 'Trouble logging in? The Service BC Help Desk is here to help.',
          phoneNumber: '1-888-356-2741',
          phoneNumberHours:
            'This phone line is answered 7:30 am - 5 pm Monday to Friday (excluding statutory holidays).',
          role: 'Role',
          emailLabel: 'Email',
          userFirstNameLabel: 'First name',
          userLastNameLabel: 'Last name',
          organizationLabel: 'Organization',
          organizationHelpText: '(if applicable)',
          register: 'Register for account',
          registerButton: 'Register',
          registerInstructions:
            'Please fill out the following registration form to create your account. Ensure all information is accurate and up-to-date.',
          certifiedProfessional: 'I am a certified professional',
          completeAccountActiviation: 'Please confirm your account',
          checkYourEmail:
            'Check your email inbox for a confirmation email to finish activating your new Building Permit Hub account.',
          tokenExpired: 'Your session is no longer valid, please login again',
          checkEligibility: {
            heading: 'Eligibility',
            home: 'Home',
            seeEligible: 'See if you’re eligible',
            aboutProgram: 'About the Energy Savings Program',
            programIntro:
              'The Energy Savings Program (ESP) offers home energy efficiency rebates based on your household income. It is an initiative of CleanBC Better Homes. It is funded by the Province of B.C., with support from the Government of Canada and BC Hydro.',
            programAffordability:
              'ESP makes energy-saving home upgrades more affordable to low- and middle-income households. Energy efficiency upgrades can help you lower your monthly energy cost. They can also help you improve year-round comfort in your home, enjoy healthier indoor air quality and reduce your greenhouse gas emissions.',
            questionInstruction:
              'You might be eligible for the Energy Savings Program. Answer these questions to find out. All questions are required (*)',
            BCAssessmentLink: 'https://www.bcassessment.ca/',
            homeQuestion: 'What kind of home do you live in? *',
            kindOfHomes: [
              'Single family home',
              'Secondary suite in a single-family home',
              'Duplex, triplex, 4–5 unit multiplex',
              'Row or side-by-side townhome',
              'Manufactured / mobile home',
              'Apartment building (6 storeys or less)',
              'Stacked townhouse building',
              'Multiplex with 6 or more units',
              'Other',
            ],
            propertyAssesmentQuestion: 'What is your property’s total assessed value? *',
            assesmentText: 'You can find the assessed value of your property on',
            BCAssessment: 'BC Assessment.',
            assesedValues: ['$1,200,000 or lower', 'Over $1,200,000', 'Unsure'],
            assesedValuesMultiUnit: ['$772,000 or lower', 'Over $772,000', 'Unsure'],

            paymentQuestion: 'Do you or a family member pay your own electricity and heating bills? *',
            paymentTextPrefix:
              'Common utility providers include BC Hydro, FortisBC, Pacific Northern Gas, City of New Westminster, City of Penticton, City of Grand Forks, Nelson Hydro, and District of Summerland.',
            paymentTextSuffix: 'Answer yes if you pay for your own wood, oil, or propane to heat your home.',
            paymentOption: ['Yes', 'No', 'Unsure'],

            // Option value keys for consistent comparisons
            optionValues: {
              homeTypeOther: 'Other',
              propertyValueHighSingle: 'Over $1,200,000',
              propertyValueHighMulti: 'Over $772,000',
              propertyValueUnsure: 'Unsure',
              paymentYes: 'Yes',
              paymentNo: 'No',
              paymentUnsure: 'Unsure',
            },
            totalPeople: 'How many people live in your home? *',
            peopleTextPrefix:
              'Include all adults and children. Include all roommates and tenants who live in the same individually metered suite or home.',
            peopleTextSuffix: 'Do not include people who live in a separate secondary suite.',
            peopleNumber: ['1', '2', '3', '4', '5', '6', '7+'],
            annualHouseholdQuestion: 'What is the combined annual household income before taxes? *',
            annualHouseholdOptions: [
              'Less than $##,###',
              'Between $##,### and $###,###',
              'Between $###, ### and $###, ###',
              'Greater than $###,###',
              'Prefer not to disclose',
            ],
            annualHouseholdValues: [
              {
                '1': [
                  'Less than $51,100',
                  'Between $51,100 and $63,900',
                  'Between $63,900 and $102,100',
                  'Greater than $102,100',
                  'Prefer not to disclose',
                ],
                '2': [
                  'Less than $63,600',
                  'Between $63,600 and $79,500',
                  'Between $79,500 and $127,200',
                  'Greater than $127,200',
                  'Prefer not to disclose',
                ],
                '3': [
                  'Less than $78,200',
                  'Between $78,200 and $97,700',
                  'Between $97,700 and $156,300',
                  'Greater than $156,300',
                  'Prefer not to disclose',
                ],
                '4': [
                  'Less than $94,900',
                  'Between $94,900 and $118,600',
                  'Between $118,600 and $189,800',
                  'Greater than $189,800',
                  'Prefer not to disclose',
                ],
                '5': [
                  'Less than $107,600',
                  'Between $107,600 and $134,500',
                  'Between $134,500 and $215,200',
                  'Greater than $215,200',
                  'Prefer not to disclose',
                ],
                '6': [
                  'Less than $121,400',
                  'Between $121,400 and $151,700',
                  'Between $151,700 and $242,700',
                  'Greater than $242,700',
                  'Prefer not to disclose',
                ],
                '7+': [
                  'Less than $135,100',
                  'Between $135,100 and $168,900',
                  'Between $168,900 and $270,200',
                  'Greater than $270,200',
                  'Prefer not to disclose',
                ],
              },
            ],
            alert: {
              eligible: 'You might be eligible for the Energy Savings Program',
              notEligible: "You're not eligible to apply",
              loginWithAccount: 'Log in to apply now',
              condoEligible: 'Condominiums and apartments are currently not eligible.',
              multiUnitNotEligible:
                'Multi-unit households valued over $772,000 are not currently eligible for Energy Savings Program rebates.',
              multiUnitUnsure:
                'This information is necessary to determine your rebate eligibility. It can be difficult to determine property value for some types of multi-unit buildings. Program administrators help when you apply.',
              propertyValueHighSingleTitle: "Your property's assessed value determines your rebate eligibility.",
              propertyValueHighSingleNotEligible:
                'Properties valued between $1,200,000 and $1,820,000 are only eligible for some Energy Savings Program rebates.',
              currentlyEligibleHome: 'Home types currently eligible for the Energy Savings Program are:',
              typesOfhome: [
                'Single-family homes or secondary suites in a single-family home',
                'Duplex, triplex, row, and townhomes',
                'Mobile homes that are fixed on a foundation and structurally complete with plumbing, electrical, sewer, and water hooked up permanently',
              ],
              otherHomes: 'Other home types are currently not eligible.',
              certainHomes: 'Only certain home types are eligible.',
              seeDetails: 'See the full eligibility requirements on Better Homes',
              provideInformation: 'You must provide this information when you apply for rebates.',
              propertyValueHigh: 'Your property’s assessed value is too high.',
              propertyValueHighDesc:
                'Your property’s assessed value must be $1,820,000 or lower to be eligible for the Energy Savings Program.',
              mustPay: 'You or a family member must pay your home’s electricity and energy bills.',
              mustPayDesc:
                'The person who pays the electricity and heating bills for this address must be the one to apply for the Energy Savings Program. If a tenant pays, their name must be listed in the tenancy agreement.',
              rangeNotEligible: 'This annual household income range is not eligible.',
              proofOfIncomeDesc:
                'When you apply to the Energy Savings Program, you must provide proof of income for all adults in the home. Eligibility is based on how many people live in the home and your combined annual income.',
              annualHouseholdDesc:
                'Energy Savings Program eligibility is based on how many people live in the home and your combined annual income.',
              assessedValDescription:
                'Your property’s assessed value must be $1,820,000 or lower to be eligible for the Energy Savings Program. Properties valued between $1,200,000 and $1,820,000 are only eligible for some Energy Savings Program rebates.',
            },
          },
        },
        landing: {
          title: 'Save energy, upgrade your home',
          intro:
            'Everyone deserves a healthy, comfortable and energy efficient home. The Better Homes Energy Savings Program rebates cover up to 100% of the cost of energy-saving home upgrades.',
          applyForEnergySaving: 'Apply for the Energy Savings Program',
          whoForTitle: 'Who is this for?',
          whoFor: [
            'You live in an eligible home in B.C.',
            'You meet income qualification requirements',
            'You have residential utility accounts with BC Hydro, FortisBC or a municipal utility',
            "You're a homeowner looking to make energy-saving upgrades to your home",
            'You’re a tenant paying your own energy utility bills and you want to help your landlord install energy-saving upgrades to your rental property',
          ],
          iNeed: 'See full eligibility details on Better Homes.',
          iNeedLink: 'https://www.betterhomesbc.ca/learn-about-programs/energy-savings-program/',
          whatToApply: 'What do I need to apply?',
          beforeApply: 'Before you apply, you will need to log in with your BC Services Card account.',
          useServiceCard: 'Learn more about how to use BC Services Card account.',
          applyNeeds: [
            [{ type: 'text', content: 'Information about your home' }],
            [{ type: 'text', content: 'The account numbers on your energy utility bills' }],
            [{ type: 'text', content: 'The number of adults living in your home' }],
            [{ type: 'text', content: 'Proof of income for all adults in your home' }],
            [
              { type: 'text', content: 'If you currently rent your home, a' },
              {
                type: 'link',
                content: {
                  text: ' Landlord Consent Form [335KB PDF]',
                  href: 'https://www.betterhomesbc.ca/esp-landlord-consent-form-PDF',
                },
              },
            ],
            [
              { type: 'text', content: 'If you live in a condo, stacked townhouse or equity co-op building, a' },
              {
                type: 'link',
                content: {
                  text: ' Strata and Equity Co-op Consent Form [260KB PDF]',
                  href: 'https://www.betterhomesbc.ca/esp-strata-equity-co-op-consent-form-PDF',
                },
              },
            ],
          ],
          contractor: {
            title: ' Energy Savings Program',
            titleDesc: 'registered contractor portal',
            description: 'Everyone deserves a healthy, comfortable, and energy efficient home.',
            itWorks: 'How it works',
            itWorksDesc:
              'Based on your customer’s household income, the Better Homes Energy Savings Program (ESP) offers rebates to make energy-saving home upgrades more affordable. Program participants work with registered contractors to complete eligible upgrades. Rebates that cover 60-100% of upgrade costs are paid directly to registered contractors and passed onto their customers.',
            learnMore: 'Learn more about the Energy Savings Program (ESP) for individuals.',
            learnMoreLink: 'https://www.betterhomesbc.ca/learn-about-programs/energy-savings-program/',
            registeredContractor: 'Become a registered contractor',
            needId: 'You will need a Business BCeID to create an account.',
            typeOfContractors: 'Heat pump, insulation, or windows and doors contractors',
            notMember: 'Not a HPCN member?',
            hpcnMember:
              'You must be a HPCN member to be an Energy Savings Program (ESP) program-registered contractor.',
            visitHome: 'Visit the Home Performance Contractor Network',
            visitHomeLink: 'https://homeperformance.ca/about-the-network/',
            toJoin:
              'to join as a heat pump, insulation, or windows and doors contractor. After signing the HPCN agreement, return to the Energy Savings Program contractor portal to register with ESP.',
            duringRegistration: 'During registration, we will ask for your:',
            businessNumber: 'Business licence number',
            healthSafetyContractors: 'Health and safety or electrical contractors',
            alreadyAccount: 'Already have an account?',
            submitInvoices: 'Log in to submit invoices and find contractor resources.',
            acknowledgement:
              'The B.C. Public Service acknowledges the territories of First Nations around B.C., and is grateful to carry out our work on these lands...',
            flow: [
              'Register and get approval',
              'Complete ESP training',
              'Log into your account',
              'Submit an invoice',
              'Receive rebate',
            ],
            registrationRequirements: [
              'Business licence number',
              'GST number',
              'WorkSafeBC membership',
              'Certificate of commercial liability insurance',
              'Technical Safety BC Certification (electrical contractors only) ',
            ],
            dashboard: {
              title: 'Contractor portal',
              invoiceSubmission: 'Invoice submissions',
              programResources: 'Program resources',
              submitInvoice: 'Submit invoice',
              uploadInfo:
                'You will need to upload your invoice and supporting documentation. Have them ready before you begin.',
            },
          },
          duringApplication: 'During the application, we will ask for:',
          informationReady: 'To make things easier, collect this information before you begin your application.',
          otherWaysTitle: 'Other ways to get started',
          getHelpTitle: 'Get help with your Energy Savings Program (ESP) application',
          energySpecialistTitle: ' Get upgrade advice from an Energy Savings Program Specialist',
          energyEfficiencyTitle: "Learn more about your home's energy efficiency",

          // Application steps
          applicationSteps: [
            'Check your eligibility quickly and easily',
            'Complete the simple step-by-step application',
            'Get approved and start your upgrades!',
          ],

          // Call to action
          getStarted: 'Get started',

          // Login status
          alreadyStarted: 'Already started an application?',
          loginToCheck: 'Log in to check on its status.',

          // Contractor section
          contractorTitle: 'Are you a contractor?',
          contractorDescriptionPart1: 'Please visit the',
          contractorDescriptionPart2:
            "and apply to be a program registered contractor. If you're already registered, you can log in to the portal to submit invoices for reimbursement.",
          contractorPortalText: 'contractor portal',
          contractorPortalLink: 'https://esp.clearesult.ca/contractor/',

          // Contact info
          phoneText: 'Call 1-833-856-0333',
          phoneHours: ', 9 am to 5 pm, Monday to Friday (excluding statutory holidays).',

          // External links
          energyCoachBooking: 'Book a call',
          //energyCoachBooking: 'Learn how to get support',
          homeEnergyPlanner: 'Use the BC Home Energy Planner',
          energySavingsProgramPortal: 'Energy Savings Program contractor portal',
          serviceCardLink: 'https://id.gov.bc.ca/account/',
          contractorPortalLinkText: 'Contractors - please visit the',

          energyCoachLink: 'https://submit.digital.gov.bc.ca/app/form/submit?f=a216ecd7-c840-457a-9f8f-b350f334849b',
          //energyCoachLink: `/get-support`,
          homeEnergyPlannerLink: 'https://bchomeenergyplanner.ca/',

          // Aria labels
          ariaLabels: {
            phoneNumber: 'Phone number',
            visitContractorPortal: 'Visit the Energy Savings Program contractor portal',
            startApplication: 'Start your Energy Savings Program application',
            loginToCheckStatus: 'Log in to check your existing application status',
            bookEnergyAssessment: 'Book a 60-minute virtual assessment with an energy specialist (opens in new window)',
            useHomePlanner:
              "Use the BC Home Energy Planner to learn about your home's energy efficiency (opens in new window)",
            visitContractorPortalRegister: 'Visit the contractor portal to register or log in',
            opensInNewWindow: '(opens in new window)',
          },

          // Additional content used by support screen
          additionalContent: {
            energyCoachBookCallLink: 'https://www.betterbuildingsbc.ca/connect/',
          },

          // Address select component
          addressSelectLabel: 'Select your address',
          cantFind: "Can't find your address?",
          browseList: 'Browse the list of eligible jurisdictions',
        },
        ui: {
          okay: 'Okay',
          until: 'til',
          reorder: 'Reorder',
          delete: 'Delete',
          confirmDelete: 'Confirm delete',
          confirmation: 'Are you sure you want to proceed?',
          confirmOverwrite: 'Are you sure you want to save and overwrite this item?',
          sureDelete: 'Are you sure you want to delete this item?',
          disable: 'Disable',
          deactivate: 'Deactivate',
          reactivate: 'Reactivate',
          reinvite: 'Re-invite',
          ok: 'OK',
          dismiss: 'Dismiss',
          revoke: 'Revoke',
          create: 'Create',
          verified: 'Verified',
          unverified: 'Unverified',
          tip: 'Tip',
          manage: 'Manage',
          export: 'Export',
          preview: 'Preview',
          back: 'Back',
          next: ' Next',
          backToInbox: 'Back to inbox',
          backHome: 'Back to home',
          yes: 'Yes',
          no: 'No',
          show: 'Show',
          viewTemplate: 'View Template',
          hide: 'Hide',
          setup: 'Setup',
          search: 'Search',
          loading: 'Loading...',
          invalidInput: 'Invalid input',
          invalidEmail: 'Invalid email',
          selectPlaceholder: 'Select',
          selectApplicable: 'Select applicable:',
          selectProgram: 'Select',
          chooseProgram: 'Select a program',
          clickHere: 'Click here',
          clickToEdit: 'Click to edit',
          clickToShow: 'Click to show',
          feedbackLink: 'Tell us what you think',
          sortBy: 'Sort by',
          resume: 'Resume',
          continue: 'Continue {{submissionType}}',
          cancel: 'Cancel',
          cancelRequest: 'Cancel request',
          remove: 'Remove',
          createAccount: 'Create account',
          save: 'Save changes',
          onlySave: 'Save',
          correctFields: 'Please correct the fields below before saving.',
          done: 'Done',
          view: 'View',
          reviewSubmission: 'Review the submission',
          checkSubmission: 'Check the submission to see why',
          completeSubmission: 'Please complete this submission',
          totalItems: 'Total items',
          doLater: 'Do this later',
          add: 'Add',
          addReason: 'Add reason',
          edit: 'Edit',
          optional: '(optional)',
          archive: 'Remove and archive',
          restore: 'Restore',
          seeArchivedButton: 'See archived',
          seeUnarchivedButton: 'See unarchived',
          never: 'never',
          submit: 'Submit',
          select: 'Select',
          assigned: 'Assigned',
          selected: 'selected',
          notAvailable: 'Not available yet',
          notApplicable: 'Not applicable',
          // isRequired: "{{field}} can't be empty",
          isRequired: "Can't be empty",
          notSupported: 'Not supported',
          use: 'Use',
          publish: 'Publish',
          neverMind: 'Never mind',
          open: 'Open',
          download: 'Download',
          expandAll: 'Expand all',
          collapseAll: 'Collapse all',
          toTop: 'Go to top',
          confirm: 'Confirm',
          modifiedBy: 'Modified by',
          editedBy: 'Edited by',
          dateEdited: 'Date edited',
          searchAddresses: 'Search addresses',
          typeToSearch: 'Begin typing to search',
          close: 'Close',
          statusasc: 'Most complete',
          statusdesc: 'Least complete',
          updated_atasc: 'oldest First',
          updated_atdesc: 'newest first',
          returnHome: 'Return to home',
          copied: 'Copied!',
          failedToCopy: 'Something went wrong while trying to copy',
          reset: 'Reset',
          autofill: 'Autofill',
          help: 'Help',
          contact: 'Contact',
          openHelpDrawer: 'Open help drawer',
          contactSupport: 'Contact Support',
          pleaseSelect: 'Please select',
          checked: 'Checked',
          unchecked: 'Unhecked',
          showAdvanced: 'Show advanced',
          hideAdvanced: 'Hide advanced',
          emailPlaceholder: 'Please enter an email',
          urlPlaceholder: 'https://',
          showOlder: 'Show older',
          seeMore: 'See more',
          go: 'Go',
          all: 'All',
          and: 'and',
          or: 'or',
          actionRequired: 'Action required',
          resetFilters: 'Reset filters',
          customize: 'Customize',
          acknowledgeAndDismiss: 'Acknowledge and dismiss',
          markedForRemoval: 'Click "Save changes" to confirm removal',
          proceed: 'Proceed',
          copy: 'Copy',
          copyNoun: 'Copy',
          options: 'Options',
          na: 'N/A',
          share: 'Share',
          unassigned: 'Unassigned',
          unassign: 'Unassign',
          seeEarlyAccessButton: 'See Early Access',
          seeLiveButton: 'See Live',
          invite: 'Invite',
          public: 'Public',
          comingSoon: 'Coming soon',
          review: 'Review',
          updateYourApplication: 'Update your application',
          viewSupportingFiles: 'View supporting file(s)',
          configure: 'Configure',
          start: 'Start',
          publishBanner: 'Ready to publish site-wide banner?',
          removeBanner: 'Ready to remove the site-wide banner?',
          approve: 'Approve',
        },
        notification: {
          title: 'Notifications',
          nTotal: '{{count}} notification',
          nTotal_other: '{{count}} notifications',
          nUnread: '{{ n }} new',
          noUnread: 'No unread notifications',
          clearAll: 'Clear All',
        },
        eula: {
          title: 'Terms and conditions',
          accept: 'Accept',
        },
        userEulas: {
          title: 'End user license agreement',
          viewAgreement: 'View agreement',
          view: 'View',
          actionRequired: 'Action required',
          acceptedOn: 'You accepted this agreement on {{date}} at {{time}}.',
          pastAgreementsModal: {
            title: 'Past end user license agreements',
            triggerButton: 'See past',
            acceptedOn: 'Accepted on {{ timestamp }}',
          },
        },
        contact: {
          create: 'New contact',
          edit: 'Edit contact',
          createButton: 'Save to my contacts',
          updateButton: 'Update contact',
          confirmDeleteTitle: 'Are you sure you want to delete this contact?',
          confirmDeleteBody: 'This will not remove information from the form.',
          fields: {
            firstName: 'First name',
            lastName: 'Last name',
            title: 'Role/Position',
            department: 'Department',
            email: 'Email',
            phone: 'Phone no.',
            extension: 'Extension',
            cell: 'Mobile no.',
            organization: 'Organization',
            address: 'Address',
            businessName: 'Business name',
            professionalAssociation: 'Professional association',
            professionalNumber: 'Professional number',
          },
        },
        program: {
          index: {
            title: 'Manage programs',
            adminTitle: 'Configure users',
            description: 'Below is a list of all programs in the system.',
            adminDescription: 'Choose the program you wish to configure users for.',
            createButton: 'Create new program',
            tableHeading: 'Programs',
            users: 'Users',
            externalApiKeys: 'API settings',
            exportTemplates: 'Export templates',
            about: 'About',
          },
          new: {
            title: 'Create new program',
            description: 'Below is a list of all programs in the system',
            createButton: 'Create program',
            tableHeading: 'Local governments',
            users: 'Users',
            externalApiKeys: 'API settings',
            exportTemplates: 'Export templates',
            about: 'About',
            targetGroup: 'Select target user group:',
            nameOfProgram: 'Name of program',
            fundedBy: 'Funded by',
            nextStep: 'Next step is to invite users.',
            successMessage: 'New program created!',
          },
          edit: {
            editProgram: 'Edit program',
          },
          fields: {
            programName: 'Name',
            reviewManagersSize: 'Managers',
            reviewersSize: 'Reviewers',
            adminManagersSize: 'Admin managers',
            adminsSize: 'Admins',
            permitApplicationsSize: 'Applications received',
            templatesUsed: 'Templates used',
          },
        },
        /* To be removed later */
        jurisdiction: {
          edit: {
            displayDescriptionLabel: 'Jurisdiction description (public)',
            addDescription: 'Click to add a description',
            displayChecklistLabel: 'Permit application checklist (public)',
            addChecklist: 'Click to add a permit application checklist',
            displayLookOutLabel: '"Look Out" Section (public)',
            addLookOut: 'Click to add a "Look Out" section',
            displayContactSummaryLabel: 'Contact Summary Section (public)',
            addContactSummary: 'Click to add a Contact Summary section',
            firstContact: 'The first contact will be displayed upon successful permit application submission.',
            clickToEditContacts: 'Click to edit contacts',
            clickToShowContacts: 'Click to show contacts as they will be seen',
            clickToEditMap: 'Click to edit map',
            clickToSeeMap: 'Click to see map',
            clickToShowMap: 'Click to show map as it will be seen',
            editMapStart: "To display a map of your jurisdiction on the 'About' page, please follow these steps:",
            editMapSteps: [
              'Identify the central point of your jurisdiction on Google Maps.',
              'Right-click on the desired central location to open a context menu.',
              'Select the option that displays the coordinates to copy them.',
              'Individually paste these coordinates into the fields below',
              'Adjust the zoom level below to your preference.',
              "Remember to click 'Save' at the bottom of the page to apply your changes.",
            ],
            editMapEnd:
              'This process ensures the map accurately represents the center of your jurisdiction and is displayed with the appropriate level of detail.',
            stepCode: {
              title: 'Step code requirements',
              description:
                'Below are the step code requirements for each permit application type. <1>What does each step code level mean?<2></2></1>',
              permitType: 'Permit type',
              energyStepRequired: 'Energy step code required',
              zeroCarbonStepRequired: 'Zero carbon step required',
            },
          },
          new: {
            title: 'Create new jurisdiction',
            createButton: 'Create jurisdiction',
            nameLabel: 'Name of local jurisdiction',
            postalAddressLabel: 'Postal address',
            nextStep: 'Next step is to invite users.',
            useCustom: 'Use a custom locality type',
          },
          index: {
            title: 'Jurisdictions',
            description: 'Below is a list of all jurisdictions in the system',
            createButton: 'Create new jurisdiction',
            tableHeading: 'Local governments',
            users: 'Users',
            externalApiKeys: 'API settings',
            exportTemplates: 'Export templates',
            about: 'About',
          },
          fields: {
            reverseQualifiedName: 'Name',
            reviewManagersSize: 'Managers',
            reviewersSize: 'Reviewers',
            localityType: 'Locality type',
            permitApplicationsSize: 'Applications received',
            templatesUsed: 'Templates used',
            mapPosition: 'Map position',
            regionalDistrictName: 'Regional district',
            submissionInboxSetUp: 'Accepting submissions',
          },
          lat: 'Latitude',
          lng: 'Longitude',
          title: 'Local housing permits',
          notEnabled: 'Permit application submissions are temporarily unavailable for this jurisdiction.',
          checklist: 'Checklist',
          lookOut: 'Things to look out for',
          startApplication: 'Start a permit application',
          contactInfo: 'Contact information',
          didNotFind: "I didn't find what I was looking for",
          viewAs: 'View as',
          name: 'Name',
          managers: 'Managers',
          reviewers: 'Reviewers',
          applicationsReceived: 'Applications received',
          templatesUsed: 'Templates used',
          search: 'Search jurisdictions',
          view: 'View Jurisdiction',
        },
        permitCollaboration: {
          status: 'Status',
          blockStatus: {
            draft: 'Draft',
            in_progress: 'In progress',
            ready: 'Ready',
          },
          sidebar: {
            triggerButton: 'Collaborators ({{count}})',
            title: 'Collaborators',
            description: {
              submission:
                'Collaborators can be invited to work on the different areas of the permit application form. Only the author can manage collaborators.',
              review: 'Collaborators can be invited to work on the different areas of the permit application form.',
            },
            howItWorksTitle: 'How it works',
            howItWorksDescription: {
              submission:
                'The collaboration feature allows the author of a permit application to invite collaborators by email. Invited collaborators must register for an account through BCeID if they do not have one already.<1/><1/> Collaborators can view and contribute only to the requirement blocks they are assigned. Notifications are sent to the collaborators when they are assigned to a requirement block, and their avatars are displayed next to the blocks they are assigned to.<1/><1/> Additionally, the designated submitter has access to the entire application and can submit it on behalf of the author. The author can manage and remove collaborators as needed.',
              review:
                'The collaboration feature allows reviewers of a submitted permit application to invite additional reviewers, provided they are already part of the jurisdiction.<1/><1/> Reviewers can view and contribute to the assigned requirement blocks and update the status of each block. Notifications are sent when reviewers are assigned to a requirement block or when the status changes to “Ready”. Avatars are displayed next to the blocks to indicate who is assigned. Status updates are visible only to reviewers within the local jurisdiction.<1/><1/> The designated reviewer serves as the primary contact internally at the local jurisdiction, responsible for overseeing the submitted permit application.',
            },
            designatedSubmitters: 'Designated submitter(s)',
            designatedReviewers: 'Designated reviewer(s)',
            authorCanSubmitWithOrganization:
              'Author of this application is also allowed to submit: <1>{{author}}</1> ({{organization}}).',
            authorCanSubmit: 'Author of this application is also allowed to submit: <1>{{author}}</1>.',
            assignees: 'Assignee(s)',
            assigneeHelperText:
              'To assign collaborators, look for the grey header at the top of each requirement block and click “Assign”.',
            noDesignatedSubmitters: 'None assigned',
            assignedTo: 'Assigned to',
            assigneeEmail: 'Email:',
            removeCollaboratorModal: {
              triggerButton: 'Remove collaborator',
              title: 'Are you sure you want to remove this collaborator?',
              body: 'This action cannot be undone.',
            },
          },
          popover: {
            triggerButton: 'Assign ({{count}})',
            designatedSubmitterChangeButton: 'Change',
            collaborations: {
              title: 'Collaborators',
              assignButton: 'Assign',
              unassignButton: 'Unassign',
              unconfirmed: 'Unconfirmed.',
              resendInvite: 'Resend invite?',
              inEligibleForReInvite: 'Ineligible for re-invite.',
            },
            assignment: {
              title: 'Assign application',
              noneAssigned: 'None assigned',
              inviteWarning: {
                title: 'Assign a collaborator?',
                body: 'When you are inviting collaborators to participate in a building permit application through our system, it’s important to understand the specific roles and permissions involved. Only the person who creates the permit application, referred to as the “author,” has the ability to invite collaborators. These collaborators are then only able to access specific sections of the application—those that they are specifically assigned to. Importantly, while the author and one person they designate (Designated Submitter) can submit the completed application, all collaborators must have a verified Building Permit HUB account using BCeID to ensure security. Additionally, the author retains the exclusive right to remove or reassign collaborators. This ensures that control over the application remains centralized while still allowing for collaborative input where necessary.',
              },
              newContactButton: 'New contact',
              noResultsText: {
                invitable: 'No results found. Invite new collaborators by clicking the button above.',
                default: 'No results found.',
              },

              unassiggn: 'Unselect',
            },
            collaboratorInvite: {
              title: 'New contact',
              inviteButton: 'Invite collaborator',
            },
          },
        },
        permitApplication: {
          submissionBlockModal: {
            title: 'Trying to submit this application?',
            description:
              'Only the designated submitter or the author can submit this permit application. Please contact that person to continue.',
            designatedSubmitter: 'Designated submitter',
            author: 'Author',
          },
          browserSearch: {
            prompt: 'Find specific form fields by using your web browser search: press keyboard shortcut',
            windows: 'Windows: <1>Ctrl</1> + <1>F</1>',
            mac: 'Mac: <1>Cmd</1> + <1>F</1> ',
          },
          updateToNewVersion: 'Update my application',
          reviewOutdatedSubmissionLink: 'View draft applications',
          reviewUpdatedEditLink: 'View template',
          reviewOutdatedTitle: 'Filters applied to show applications that are outdated',
          reviewOutdatedMessage: 'Filters have been applied. Please review and acknowledge the actions required below.',
          reviewCustomizedSubmissionLink: 'View draft applications',
          reviewCustomizedTitle: 'Filters applied to show applications that have new customizations added',
          reviewCustomizedMessage: 'Filters have been applied. Please review the draft applications below.',
          newVersionPublished: 'New version of template has been published - please review changes',
          card: {
            collaborateButton: 'Collaborate',
            collaborationCalloutDraft:
              '<1>{{authorName}} has assigned you to this permit.</1> Collaborate on this permit application.',
            collaborationCalloutSubmitted: '<1>{{authorName}} assigned you to this permit.</1>',
          },
          referenceNumber: 'Reference #',
          pdf: {
            for: 'Permit application for',
            id: 'Reference #',
            submissionDate: 'Submission date',
            applicant: 'Applicant',
            jurisdiction: 'Jurisdiction',
            page: 'Page {{pageNumber}} / {{totalPages}}',
            fileNotAdded: 'Not uploaded',
            permitType: 'Permit type',
            contactInfo: 'Contact information',
            applicantInfo: 'Applicant contact details',
          },
          usePid: "Use '{{ inputValue }}' as PID",
          indexTitle: 'My active permits',
          start: 'Start a permit application',
          drafts: 'Draft Permits',
          startedOn: 'Started',
          lastUpdated: 'Last updated',
          viewedOn: 'Viewed on',
          seeBestPractices_CTA: 'See best practices',
          seeBestPractices_link:
            'https://www2.gov.bc.ca/gov/content/housing-tenancy/building-or-renovating/permits/building-permit-hub#practices',
          searchKnowledge_CTA: 'Ask a question',
          searchKnowledge_link:
            'https://www2.gov.bc.ca/gov/content/housing-tenancy/building-or-renovating/permits/building-permit-hub-search',
          pidLabel: 'Parcel Identification (PID) No.',
          addressLabel: 'Address',
          viewed: 'Viewed',
          notViewed: 'New',
          newlyRevised: 'Newly revised',
          status: {
            new_draft: 'Draft',
            newly_submitted: 'Submitted',
            resubmitted: 'Resubmitted',
            revisions_requested: 'Revisions Requested',
            ephemeral: 'Preview',
          },
          statusGroup: {
            draft: 'Draft permits',
            submitted: 'Submitted permits',
          },
          columns: {
            number: 'Reference #',
            reference_number: 'Reference #',
            permit_classification: 'Types',
            submitter: 'Submitter',
            submitted_at: 'Submitted',
            submission_type: 'Type',
            viewed_at: 'Viewed at',
            updated_at: 'Last Updated',
            status: 'Status',
            assigned: 'Assigned',
            actions: 'Actions',
          },
          submissionInbox: {
            contactInviteWarning:
              'Please have a Review Manager setup the Submissions Inbox for all permit types to allow submissions to be received.',
            title: 'Submissions inbox',
            tableHeading: 'Permit applications',
            chooseProgram: 'Choose a program from the drop down list.',
            tableDescription:
              'Choose a submission inbox to view from the dropdown list. Submitted applications will appear in the relevant submission inbox. ',
          },
          fields: {
            number: 'Reference #',
            pin: 'PIN',
            jurisdiction: 'Jurisdiction',
          },
          new: {
            locationHeading: 'Location for permit',
            submitToOwn:
              'Make sure you are submitting to a jurisdiction that you have inbox access to so that you can see it.',
            sandboxIdHeading: 'Submit into Sandbox',
            onlyHavePin: 'I only have a PIN',
            dontHavePin: "I don't have a PIN",
            selectSandboxLabel: 'Select a sandbox to submit into',
            firstNationsTitle: 'First Nations',
            permitTypeHeading: 'Permit type',
            workTypeHeading: 'Work type',
            forFirstNations: 'Is this permit application on <1>First Nation Registered Land</1>?',
            applicationDisclaimerInstruction:
              'Before you submit a building permit application, please ensure your proposed building siting and design complies with:',
            applicationDisclaimers: [
              { text: 'provincial building code', href: 'https://www.bccodes.ca/building-code.html' },
              {
                text: 'local zoning bylaw',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/land-use-regulation/zoning-bylaws',
              },
              {
                text: 'official community plan regulations',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/local-government-planning/official-community-plans',
              },
              {
                text: 'applicable development permit areas',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/land-use-regulation/development-permit-areas',
              },
              {
                text: 'variances outlined in a local bylaw',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/land-use-regulation/zoning-bylaws/board-of-variance',
              },
            ],
            applicationDisclaimerMoreInfo:
              'For more information and specific building drawing requirements and checklists, contact your local jurisdiction.',
            applicationDisclaimerMoreInfo_CTA: 'Find your local jurisdiction',
            applicationDisclaimerMoreInfo_Link:
              'https://www2.gov.bc.ca/gov/content/governments/local-governments/facts-framework/local-government-maps',
            submitted: 'Your application has been submitted!',
            hearBack: 'Need Help?',
            contactInstruction:
              'You can log into the Building Permit Hub at any time to view a history of the applications you have submitted. Please contact the {{ jurisdictionName }} for questions related to your application.',
            whatsNextTitle: "What's next?",
            ready: 'Ready to submit this application?',
            bySubmitting: 'By submitting this application',
            confirmation:
              'You confirm that the information you provided was completed to the best of your knowledge and ability',
            yourReference: 'Your reference # is {{ number }}',
            noContactsAvailable:
              'This jurisdiction is not ready to accept applications through this tool yet. Please check with your local jurisdiction.',
            whatsNext:
              'We will review your application. If we need more information or change the status of your application, we will send you an email. Please check your inbox regularly for updates to your application.',
            emailed: 'You will receive a confirmation email.',
            pinRequired: 'PID not found or unavailable. Please select a PIN and jurisdiction below:',
            pinVerified: 'PIN is verified.',
            pinUnableToVerify: 'Unable to verify PIN, please confirm and proceed as applicable.',
            needToKnow: 'What you need to know',
            disclaimer1:
              'You can use this website to submit a permit application for your building project. This website checks if your application meets some codes, but approval isn’t automatic.',
            disclaimer2:
              'After you’ve submitted your application, local officials will review it. They may ask you to fix issues or show that your application meets requirements before approving it.',
          },
          withdraw: {
            confirmTitle: 'Are you sure you want to withdraw this {{submissionType}} form?',
            confirmMessage: 'By withdrawing this {{submissionType}} form your draft will not be saved.',
            confirm: 'Withdraw application',
            success: {
              title: 'Your application has been withdrawn.',
              subtitleEmail: 'You will receive a confirmation email.',
            },
          },
          edit: {
            saveDraft: 'Save and finish later',
            withdrawl: 'Withdraw',
            submit: 'Submit',
            permit: 'Permit',
            fullAddress: 'Full address',
            pidPin: 'PID / PIN',
            clickToWriteNickname: 'Click to write a nickname',
          },
          show: {
            update: 'Update',
            screenIn: 'Screen in',
            inEligible: 'Ineligible',
            wasSubmitted: 'Application was submitted on {{ date }} to {{ jurisdictionName }}',
            submittingTo: {
              title: "You're applying to the {{ jurisdictionName }}",
              description:
                'Please verify that this building permit is in compliance with <1>local zoning bylaws</1> for this specific location.',
            },
            versionDiffContactWarning:
              'A new version of the permit is available. Please ask author or designated submitter to review and acknowledge changes to proceed.',
            contactsSummary: 'Contacts summary',
            downloadApplication: 'Download application',
            fetchingMissingPdf: 'Fetching {{missingPdf}}...',
            missingPdfLabels: {
              permitApplication: 'permit application pdf',
              stepCode: 'step code checklist pdf',
            },
            contactSummaryHeading: 'List of all contacts on this application',
            downloadHeading: 'Download application',
            downloadPrompt: 'Choose specific files or entire package:',
            downloadZip: 'Download attached files',
            downloadForm: 'Download application form',
            downloadStepCode: 'Download step code checklist',
            requestRevisions: 'Request revisions',
            viewRevisionRequests: 'View revision requests',
            requestingRevisions: 'Requesting revisions',
            requestedRevisions: 'Requested revisions',
            pleaseFix: 'Please fix the requested revisions and re-submit your application',
            onlySpecified:
              'Only the the specified fields highlighted below (in yellow) and their corresponding blocks can be edited',
            showList: 'Show list',
            hideList: 'Hide list',
            backToInbox: 'Back to inbox',
            locateRevisions: 'Locate each requested revision by clicking the links below.',
            revisionsWereRequested: 'Revisions to this application were requested on {{date}}',
            clickQuestion: 'Click on the question(s) or requirement(s) you want the submitter to revise.',
            revision: {
              newRevision: 'New revision',
              pastRequests: 'Past requests',
              reason: 'Reason',
              reasonCode: 'Reason code',
              revisionRequest: 'Request update',
              reasonFor: 'Reason for revision',
              comment: 'Comment (Optional)',
              useButton: 'Use this reason',
              updateField: 'Update Field',
              maxCharacters: '{{count}} / {{max}} characters',
              send: 'Send to submitter',
              confirmHeader: 'Send this list of revisions to the submitter?',
              originallySubmitted: 'Previously submitted',
              confirmMessage: "The submitter will receive a notification end email about the changes you've requested.",
            },
          },
          review: {
            readyToMarkIneligible: 'Ready to mark ineligible?',
            readyToApprovePending: 'Ready to mark approved - pending?',
            readyToMarkPaid: 'Ready to mark approve - paid?',
            confirmIneligible: 'I confirm that this {{submissionType}} is ineligible for the Energy Savings Program.',
            readyToScreen: 'Ready to screen in?',
            confirmReview: 'I confirm this {{submissionType}} has all the required information.',
            screenedInSuccess: 'You have screened in this {{submissionType}} form to in review.',
            contractor: {
              readyToMarkIneligible: 'Ready to mark this contractor ineligible?',
            },
          },
        },
        contractorOnboarding: {
          contractorId: 'Reference #',
          readyContractor: 'Ready to submit your registration details?',
          confirmationContractor:
            'By submitting your registration details you confirm that the information you provided was completed to the best of your knowledge and ability.',
          submissionSuccess: 'Your {{ submissionType }} form has been submitted',
          whatsNext: {
            heading: "What's next?",
            line1:
              'Please wait while we assess your registration details. If we need more information, we will reach out to the email you registered with. We will email you with next steps once we have reviewed your submission.',
            line2:
              'If you need to add, edit, or remove employees from your account in the future you will need to email us. If you have any questions, please call 833-856-0333 or email <1>{{email}}</1>.',
          },
          returnToDashboard: 'Back to contractor homepage',
          trainingPending: {
            confirmReadyTitle: 'Ready to mark this contractor as training pending?',
            confirmReadyMessage: 'I confirm this {{submissionType}} form has all the required information.',
            successTitle: 'Training pending for contractor.',
            successMessage: 'Email the contractor with a link to the training materials.',
          },
          approval: {
            confirmTitle: 'Ready to approve this contractor?',
            confirmMessage: 'I confirm this {{submissionType}} form has all the required information.',
            successTitle: 'You have marked this contractor as approved.',
            successMessage: 'An email has been automatically sent to the contractor.',
          },
          revision: {
            updateReason: 'Contractor Onboarding Form',
          },
        },
        invoices: {
          selection: {
            pageTitle: 'Select an invoice type',
            errorNoSelection: 'Please select an invoice type before continuing.',
            noInvoicesFound: 'No invoices found',
          },
        },
        energySavingsApplication: {
          returnToDashboard: 'Return to dashboard',
          submissionBlockModal: {
            title: 'Trying to submit this application?',
            description:
              'Only the designated submitter or the author can submit this permit application. Please contact that person to continue.',
            designatedSubmitter: 'Designated submitter',
            author: 'Author',
          },
          browserSearch: {
            prompt: 'Find specific form fields by using your web browser search: press keyboard shortcut',
            windows: 'Windows: <1>Ctrl</1> + <1>F</1>',
            mac: 'Mac: <1>Cmd</1> + <1>F</1> ',
          },
          updateToNewVersion: 'Update my application',
          returnHome: 'Return to supported applications',
          returnToMain: 'Return to home',
          reviewOutdatedSubmissionLink: 'View draft applications',
          reviewUpdatedEditLink: 'View template',
          reviewOutdatedTitle: 'Filters applied to show applications that are outdated',
          reviewOutdatedMessage: 'Filters have been applied. Please review and acknowledge the actions required below.',
          reviewCustomizedSubmissionLink: 'View draft applications',
          reviewCustomizedTitle: 'Filters applied to show applications that have new customizations added',
          reviewCustomizedMessage: 'Filters have been applied. Please review the draft applications below.',
          newVersionPublished: 'New version of template has been published - please review changes',
          card: {
            viewActionButton: 'View {{submissionType}}',
            genericSubmissionType: 'submission',
            viewApplication: 'View application',
            continueButton: 'Continue',
            collaborateButton: 'Collaborate',
            collaborationCalloutDraft:
              '<1>{{authorName}} has assigned you to this permit.</1> Collaborate on this permit application.',
            collaborationCalloutSubmitted: '<1>{{authorName}} assigned you to this permit.</1>',
            actionRequired: 'Action required:',
            reviewActionText:
              'An agent has reviewed your {{submissionType}} and needs more information. Please review and update your {{submissionType}}.',
            supportingFileSubmissionText: 'An admin has submitted supporting files on your behalf.',
            supportingFileParticipantSubmissionText: 'You have submitted the requested supporting files.',
            uploadFilesText: 'Please upload {{additionalText}}',
            uploadFilesTextNoList: 'Please upload the requested supporting files.',
            requestedOn: 'Requested: {{date}}',
            submittedOn: 'Submitted: {{date}}',
            submittedNoDate: 'Submitted',
          },
          referenceNumber: 'Reference #',
          pdf: {
            for: 'Permit application for',
            id: 'Reference #',
            submissionDate: 'Submission date',
            applicant: 'Applicant',
            jurisdiction: 'Jurisdiction',
            page: 'Page {{pageNumber}} / {{totalPages}}',
            fileNotAdded: 'Not uploaded',
            permitType: 'Permit type',
            contactInfo: 'Contact information',
            applicantInfo: 'Applicant contact details',
          },
          consent: {
            title: '  Collection of consent',
            acknowledgement: 'I acknowledge that the participant has consented to this update.',
          },
          usePid: "Use '{{ inputValue }}' as PID",
          indexTitle: 'My applications',
          start: 'Start an application',
          newInvoiceSubmission: 'start a new invoice submission',
          drafts: 'Draft Permits',
          startedOn: 'Started',
          lastUpdated: 'Last updated',
          viewedOn: 'Viewed on',
          seeBestPractices_CTA: 'See best practices',
          seeBestPractices_link:
            'https://www2.gov.bc.ca/gov/content/housing-tenancy/building-or-renovating/permits/building-permit-hub#practices',
          searchKnowledge_CTA: 'Ask a question',
          searchKnowledge_link:
            'https://www2.gov.bc.ca/gov/content/housing-tenancy/building-or-renovating/permits/building-permit-hub-search',
          pidLabel: 'Parcel Identification (PID) No.',
          addressLabel: 'Address',
          viewed: 'Viewed',
          notViewed: 'New',
          newlyRevised: 'Newly revised',
          reset: 'Reset',
          status: {
            new_draft: 'Draft',
            newly_submitted: 'Submitted',
            resubmitted: 'Resubmitted',
            revisions_requested: 'Update needed',
            ephemeral: 'Preview',
            in_review: 'In Review',
            approved: 'Approved',
            approved_pending: 'Approved - Pending',
            approved_paid: 'Approved - Paid',
            training_pending: 'Training Pending',
            ineligible: 'Ineligible',
            screen_in: 'In Review',
            unread: 'Unread',
          },
          filter: {
            draft: 'Draft',
            submitted: 'Submitted',
            inReview: 'In Review',
            approved: 'Approved',
            ineligible: 'Ineligible',
            resubmitted: 'Resubmitted',
            revisionsRequested: 'Update needed',
          },
          statusGroup: {
            filter: 'Filter',
            all: 'All',
            draft: 'Draft',
            submitted: 'Submitted',
            resubmitted: 'Resubmitted',
            inReview: 'In Review',
            underReview: 'In Review',
            revisionsRequested: 'Update needed',
            approved: 'Approved',
            approvedPending: 'Approved - Pending',
            approvedPaid: 'Approved - Paid',
            trainingPending: 'Training Pending',
            ineligible: 'Ineligible',
          },
          columns: {
            number: 'Application #',
            reference_number: 'Reference #',
            permit_classification: 'Types',
            submitter: 'Submitter',
            submitted_at: 'Submitted at',
            viewed_at: 'Viewed at',
            status: 'Status',
          },
          submissionInbox: {
            tableSubHeading: 'Participant applications',
            chooseProgram: 'Choose a program from the drop down list.',
            chooseSubmissionInbox: 'Choose a submission inbox from the drop down list.',
            participantSubmission: 'Participant submission inbox',
            titles: {
              participant: 'Participant submissions',
              contractor: 'Contractor submissions',
              contractorOnboarding: 'Contractor onboarding submissions',
            },
            contractorSubmission: 'Contractor submission inbox',
            contractorOnboarding: 'Contractor onboarding submission inbox',
            assignedTo: 'Assigned to me',
            noAccess: 'You do not have access to any programs',
            contactInviteWarning:
              'Please have a Review Manager setup the Submissions Inbox for all permit types to allow submissions to be received.',
            title: 'Submissions inbox',
            tableHeading: 'Permit applications',
            submissionsSentTo:
              'A copy of all submitted applications are also sent to one or more email addresses configured by the review manager.',
          },
          fields: {
            number: 'Reference #',
            pin: 'PIN',
            jurisdiction: 'Jurisdiction',
          },
          new: {
            fillApplication: "Select an application to fill out on someone's behalf:",
            selectBlankApplication: 'Select a blank application you would like to view:',
            program: 'Program',
            lastUpdated: 'Last updated:',
            startApplication: 'Start an application',
            noTemplate: 'No templates available for this program.',
            sucessfulSubmission: 'Application submitted',
            viewAllSubmissions: 'View all submissions',
            locationHeading: 'Location for permit',
            submitToOwn:
              'Make sure you are submitting to a jurisdiction that you have inbox access to so that you can see it.',
            sandboxIdHeading: 'Submit into Sandbox',
            onlyHavePin: 'I only have a PIN',
            dontHavePin: "I don't have a PIN",
            selectSandboxLabel: 'Select a sandbox to submit into',
            firstNationsTitle: 'First Nations',
            permitTypeHeading: 'Permit type',
            workTypeHeading: 'Work type',
            forFirstNations: 'Is this permit application on <1>First Nation Registered Land</1>?',
            applicationDisclaimerInstruction:
              'Before you submit a building permit application, please ensure your proposed building siting and design complies with:',
            applicationDisclaimers: [
              { text: 'provincial building code', href: 'https://www.bccodes.ca/building-code.html' },
              {
                text: 'local zoning bylaw',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/land-use-regulation/zoning-bylaws',
              },
              {
                text: 'official community plan regulations',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/local-government-planning/official-community-plans',
              },
              {
                text: 'applicable development permit areas',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/land-use-regulation/development-permit-areas',
              },
              {
                text: 'variances outlined in a local bylaw',
                href: 'https://www2.gov.bc.ca/gov/content/governments/local-governments/planning-land-use/land-use-regulation/zoning-bylaws/board-of-variance',
              },
            ],

            applicationDisclaimerMoreInfo:
              'For more information and specific building drawing requirements and checklists, contact your local jurisdiction.',
            applicationDisclaimerMoreInfo_CTA: 'Find your local jurisdiction',
            applicationDisclaimerMoreInfo_Link:
              'https://www2.gov.bc.ca/gov/content/governments/local-governments/facts-framework/local-government-maps',
            submitted: 'You sent this application for review.',

            submissionSuccess: 'Your {{ submissionType }} form has been submitted!',
            staffSubmissionSuccess: '{{ submissionType }} form has been submitted!',
            confirmationEmail: 'A confirmation email has been sent to your account.',
            hearBack: 'Need help?',
            contactInstruction:
              'See the status of your application or your application history any time by logging in to the Better Homes Energy Savings Program. Contact <1>{{ email }}</1> if you have any questions about your application.',
            contractorInvoiceContactInstruction:
              'You can log into the Better Homes Energy Savings Program to view your submitted forms. Please contact <1>{{ email }}</1> for questions related to your form.',
            whatsNextTitle: "What's next?",
            ready: 'Ready to submit this application form?',
            onBehalf: 'Ready to submit on someone’s behalf?',
            bySubmitting: 'By submitting this application',
            confirmationOnBehalf:
              'I confirm that the information provided is accurate to the best of my knowledge. The applicant has given consent for me to submit this application on their behalf.',
            confirmation:
              'By submitting this {{submissionType}} form you confirm that the information you provided was completed to the best of your knowledge and ability',
            yourReference: 'Reference # {{ number }}',
            noContactsAvailable:
              'This jurisdiction is not ready to accept applications through this tool yet. Please check with your local jurisdiction.',
            whatsNext:
              "Upon receipt by the local jurisdiction, you will be notified via email or phone of any updates to your application's status or if additional documentation is required.",
            emailed:
              'A confirmation email has also been sent to the applicant and the {{ jurisdictionName }} building permit office',
            pinRequired: 'PID not found or unavailable. Please select a PIN and jurisdiction below:',
            pinVerified: 'PIN is verified.',
            pinUnableToVerify: 'Unable to verify PIN, please confirm and proceed as applicable.',
            needToKnow: 'What you need to know',
            disclaimer1:
              'You can use this website to submit a permit application for your building project. This website checks if your application meets some codes, but approval isn’t automatic.',
            disclaimer2:
              'After you’ve submitted your application, local officials will review it. They may ask you to fix issues or show that your application meets requirements before approving it.',
          },
          withdraw: {
            confirmTitle: 'Are you sure you want to withdraw this {{submissionType}} form?',
            confirmMessage: 'By withdrawing this {{submissionType}} form your draft will not be saved.',
            confirmMessageOnboarding:
              'If you withdraw, your draft will not be saved. You can restart the onboarding process if you decide to register in future.',
            confirm: 'Withdraw application',
            success: {
              title: 'Your {{submissionType}} form has been withdrawn.',
              subtitleEmail: 'You will receive a confirmation email.',
            },
          },
          review: {
            ineligibleNextSteps: 'An email has been automatically sent to the submitter with the ineligible reason.',
            markedIneligible: 'You have marked this application ineligible.',
            readyToMarkIneligible: 'Ready to mark ineligible?',
            confirmIneligible: 'I confirm that this {{submissionType}} is ineligible for the Energy Savings Program.',
            readyToScreen: 'Ready to screen in?',
            confirmReview: 'I confirm this {{submissionType}} has all the required information.',
            screenedInSuccess: 'You have screened in this {{submissionType}} form to in review.',
            approvedPendingSuccess: 'You have marked this {{submissionType}} form approved - pending.',
            approvedPaidSuccess: 'You have marked this {{submissionType}} form approved - paid.',
            approvedPaidSuccessSubtitle: 'An email has been automatically sent to the submitter.',
            inEligibleReasonReminder: 'Email the contractor with a reason for ineligibility.',
            admin: {
              markedIneligible: 'You have marked this {{submissionType}} form ineligible.',
            },
          },
          edit: {
            back: 'Back to My applications',
            saveDraft: 'Save and finish later',
            withdrawl: 'Withdraw',
            submit: 'Submit',
            permit: 'Permit',
            fullAddress: 'Full address',
            pidPin: 'PID / PIN',
            clickToWriteNickname: 'Click to write a nickname',
            revisionReady: 'Ready to resubmit this {{submissionType}} form?',
            revisionConfirmation:
              'You confirm that the information you have provided was completed to the best of your knowledge and ability.',
            revisionSubmissionSuccess: 'Your {{submissionType}} form has been resubmitted.',
          },
          show: {
            update: 'Update',
            readyForTraining: 'Ready for training',
            approvePending: 'Approve pending',
            approvePaid: 'Approve paid',
            markIneligible: 'Mark ineligible',
            screenIn: 'Screen in',
            inEligible: 'Ineligible',
            wasSubmitted: 'Application was submitted on {{ date }} to {{ jurisdictionName }}',
            submittingTo: {
              title: "You're applying to the {{ jurisdictionName }}",
              description:
                'Please verify that this building permit is in compliance with <1>local zoning bylaws</1> for this specific location.',
            },
            versionDiffContactWarning:
              'A new version of the permit is available. Please ask author or designated submitter to review and acknowledge changes to proceed.',
            contactsSummary: 'Contacts summary',
            downloadApplication: 'Download application',
            viewApplicationFiles: 'View supporting files',
            fetchingMissingPdf: 'Fetching {{missingPdf}}...',
            missingPdfLabels: {
              permitApplication: 'permit application pdf',
              stepCode: 'step code checklist pdf',
            },
            contactSummaryHeading: 'List of all contacts on this application',
            downloadHeading: 'Download application',
            viewFilesHeading: 'View files',
            downloadPrompt: 'Choose specific files or entire package:',
            viewFilesPrompt: 'Choose specific files to view:',
            downloadZip: 'Download attached files',
            downloadForm: 'Download application form',
            downloadStepCode: 'Download step code checklist',
            requestRevisions: 'Request revisions',
            viewRevisionRequests: 'View revision requests',
            requestingRevisions: 'Requesting revisions',
            updatesTracker: 'Updates tracker',
            reviewNotes: 'Review notes',
            updatePathway: 'Update pathway',
            performedBy: 'Update performed by',
            updatePathwayOptions: {
              participantOption: '{{userGroup}} (send request to them)',
              adminOption: "Admin (on {{userGroup}}'s behalf)",
            },
            applicant: 'Applicant',
            staff: 'Staff',
            saveEdits: 'Save edits',
            saveConfirmation: {
              title: 'Are you ready to save the updates you have made to this application ?',
              description:
                "The updates you have made on this application will be used to assess the submitter's eligibility.",
              confirm: 'Confirm',
              back: 'Back',
            },
            adminSaveSuccess: '{{submissionType}} form has updated.',
            adminSaveError: 'There was an error saving the application updates. Please try again.',
            requestedRevisions: 'Requested revisions',
            pleaseFix: 'Please fix the requested revisions and re-submit your application',
            onlySpecified:
              'Only the the specified fields highlighted below (in yellow) and their corresponding blocks can be edited',
            showList: 'Show list',
            hideList: 'Hide list',
            backToInbox: 'Back to inbox',
            locateRevisions: 'Locate each requested revision by clicking the links below.',
            revisionsWereRequested: 'Updates to this application were requested on {{date}}',
            applicationStatusTitle: 'Timeline',
            applicationSubmitted: '{{submissionType}} was submitted on {{date}}',
            applicationScreenedIn: '{{submissionType}} was screened in on {{date}}',
            applicationCreated: '{{submissionType}} was created on {{date}}',
            applicationUpdated: '{{submissionType}} was last updated on {{date}}',
            clickQuestion: 'Click on the question(s) or requirement(s) you want the submitter to revise.',
            clickQuestionUpdate: 'Click on the question(s) or requirement(s) you want to update.',
            inEligibleDetails: 'Ineligible {{submissionType}} form details',
            applicationId: 'Reference # is #',
            inEligibleReason: 'Reason this {{submissionType}} form is ineligible:',
            inEligibleReasonShort: 'Ineligible reason:',
            revision: {
              newRevision: 'New revision',
              pastRequests: 'Past requests',
              reason: 'Reason',
              reasonCode: 'Reason code',
              revisionRequest: 'Request update',
              reasonFor: 'Reason for revision',
              reasonForUpdate: 'Reason for update',
              newUpdate: 'New update',
              originalAnswer: 'Original answer',
              noOriginalAnswer: 'No original answer provided',
              updateFieldButton: 'Update field',
              removeButton: 'Remove',
              comment: 'Comment (Optional)',
              useButton: 'Use this reason',
              maxCharacters: '{{count}} / {{max}} characters',
              send: 'Send to submitter',
              confirmHeader: 'Send this list of update requests to the submitter?',
              originallySubmitted: 'Previously submitted',
              confirmMessage:
                "The submitter will receive an notification and email about the changes you've requested.",
              cancelRequest: 'Are you sure you want to cancel?',
              noNotification:
                'No notifications will be sent to the applicant and you will lose any current revisions you may have added.',
            },
            supportingFilesRequest: {
              addSupportingFiles: 'Add supporting files',
              selectionAction: 'Selection action',
              requestSupportingFiles: 'Request supporting files',
              listOfSupportingFiles: 'List of supporting files',
              prompt:
                'List the required files below, one line per file. Each line will be a bullet point in the email to the participant.',
              requestedHeader: 'Supporting files requested',
              requestedText: 'Supporting files have been requested from the participant on {{date}}',
              confirmationText: 'Are you sure you want to request supporting files for {{applicationNumber}}?',
              readyToUpload: 'Are you ready to upload your supporting file(s) for {{applicationNumber}}?',
              filesAdded: 'Supporting files added on {{date}}',
              filesUploaded: 'Supporting file(s) successfully uploaded',
            },
            internalComments: {
              title: 'Comments',
              addComment: 'Manage comments',
              prompt: 'Only Admins and Admin managers can see these comments.',
              placeholder: 'Add a comment...',
              post: 'Post comment',
              emptyState: 'No comments yet.',
              unknownAuthor: 'Unknown',
              delete: 'Delete comment',
              deleteConfirm: 'Delete this comment?',
            },
          },
        },
        sandbox: {
          formLabel: 'Sandbox',
          live: 'Live (None)',
          disabledFor: 'Disabled for sandbox',
          inMode: "You're in testing mode:",
          switch: {
            label: 'Sandbox mode',
            title: 'Enter testing sandbox mode?',
            description: 'While in this mode, you will be able to:',
            descriptionList: [
              'make changes to a permit template without affecting what is published live.',
              'publish permit templates for testing it out as how a submitter would see it',
              'if you made any changes on a permit, you may choose to copy those over to publish live.',
            ],
            choicesAvailable: 'Choices available',
            liveDescription: '<strong>Live</strong>: No sandbox. Submit directly to the live inbox.',
            publishedDescription:
              '<strong>Published sandbox:</strong> Sandbox that emulates the live mode by letting you test edits on published permit templates.',
            scheduledDescription:
              '<strong>Scheduled sandbox:</strong> Sandbox that lets you interact with scheduled permit templates.',
            continue: 'Continue to sandbox',
            superAdminAvailable: 'Super Admin feature available!',
            testingPurposes: 'For testing purposes, you may choose which permit applications to test.',
          },
        },
        earlyAccessRequirementsLibrary: {
          index: {
            title: 'Early access requirements library',
            description:
              "This displays all requirement blocks whose visibility has been set to 'preview only'. These blocks may not be used in any live drafts.",
            tableHeading: 'Early access requirement blocks',
          },
        },
        requirementsLibrary: {
          addAnother: 'Add',
          addAnotherPerson: 'Add another person',
          elective: 'Elective',
          hasElective: 'Has elective(s)',
          forFirstNations: 'Intended for First Nations',
          hasConditionalLogic: 'Has conditional logic',
          hasAutomatedCompliance: 'Has automated compliance',
          inputNotSupported: 'Input type not yet supported',
          associationsInfo: 'Sections, tags, etc...',
          copyToEarlyAccess: {
            title: 'Copy to early access',
            body: 'Do you want to deuplicate this into an early access requirement block? <br /> <br /> <strong>Replace and duplicate with early access:</strong>',
            replaceButton: 'Replace requirement block',
          },

          index: {
            title: 'Requirements library',
            description: 'List of all Requirement Blocks in the system that can be used inside Templates.',
            tableHeading: 'Requirement blocks',
            createButton: 'Create new requirement block',
          },
          fieldsDrawer: {
            formFields: 'Form fields',
            useButton: 'Use',
            dummyOption: 'Option',
          },
          visibilityDescriptions: {
            any: 'No restrictions on visibility.',
            live: 'Can only be used in live templates only. Does not affect published templates.',
            earlyAccess:
              'Available to be used in early access preview templates only. Does not affect published templates',
          },
          visibility: {
            any: 'Any',
            live: 'Preview omitted',
            earlyAccess: 'Preview only',
          },
          modals: {
            archived: 'Archived',
            unlabeled: 'Unlabeled',
            defaultContactLabel: 'Contact',
            canAddMultipleContacts: 'Submitter can add multiple contacts',
            addLabel: 'Add label',
            displayDescriptionLabel: 'Instruction/Description (public)',
            addDescriptionTrigger: 'Add instructions/description for this block',
            visibilityLabel: 'Visibility',
            cantEditHere: 'Not currently editable here',
            changeVisibility: {
              fromEarlyAccessTitle: 'Are you sure you want to promote this?',
              fromLiveTitle: 'Are you sure you want to promote this?',

              confirmChangeBody1:
                'This is only possible if the block only currently exists in the correct corresponding in-progress template drafts and previews. Once changed, it will be in the corresponding library only',
              confirmChangeBody2:
                'Make sure you are ready to promote/demote this, any other previews or templates using this specific block will also reflect this change.',
              listItem1: '<strong>All</strong>: The requirement block may exist in any preview or template',
              listItem2:
                '<strong>Exclude preview</strong>: The requirement block may not exist in previews, and only in templates',
              listItem3:
                '<strong>Preview only</strong>: The requirement block may not exist in templates, and only in previews',
            },
            create: {
              triggerButton: 'Create new requirement block',
              title: 'New requirement block',
            },
            edit: {
              title: 'Edit requirement block',
              options: 'Options',
              copy: 'Copy this block',
              visibilityTooltip:
                'Visibility determines if the block is restricted to live, early-access previews, or both',
              removeConfirmationModal: {
                title: 'Confirm you want to archive this requirement block.',
                body: 'Archiving this requirement blocks will remove it from all draft templates. This action cannot be undone.',
              },
            },
            clickToWriteDisplayName: 'Click to write display name',
            clickToWriteDescription: 'Click to write description',
            clickToWriteNickname: 'Click to write nickname',
            blockSetupTitle: 'Block setup',
            internalUse: 'For internal use only',
            configureFields: 'Configure the form fields below that submitters will see:',
            noFormFieldsAdded: 'No form fields have been added yet, start by clicking the Add button.',
            defaultRequirementLabel: 'Label',
            addHelpText: 'Add help text',
            addHelpTextLabel: 'Help text',
            editHelpTextLabel: 'Edit help text',
            helpTextPlaceHolder: 'Help text',
            optionalForSubmitters: 'This field is optional for submitters',
            isAnElectiveField: 'This is an elective field for local jurisdictions',
            optionsMenu: {
              triggerButton: 'Options',
              remove: 'Remove',
              conditionalLogic: 'Conditional logic',
              automatedCompliance: 'Automated compliance',
              dataValidation: 'Data validation',
            },
            conditionalSetup: {
              ge: 'Greater or equal to',
              le: 'Less than or equal to',
              gt: 'Greater than',
              lt: 'Less than',
              ne: 'Not equal to',
              when: 'For question:',
              eq: 'Equals',
              satisfies: 'Submitter responds with:',
              then: 'Then...',
              show: 'Show this field',
              hide: 'Hide this field',
            },
            computedComplianceSetup: {
              module: 'Module',
              valueExtractionField: 'Value extraction field',
              optionsMapGrid: {
                title: 'Options mapper',
                externalOption: 'External option',
                requirementOption: 'Requirement option',
              },
            },
            addOptionButton: 'Add another option',
            templateEditWarning:
              'Any changes made here will be reflected in all unsaved preview drafts that use this requirement block.',
            previewEditWarning:
              'Any changes made here will be reflected in all in-progress template drafts that use this requirement block.',
            templates: 'templates',
            previews: 'previews',
            stepCodeDependencies: {
              energyStepCodeMethod: {
                tool: 'Utilizing the digital step code tool',
                file: 'By file upload',
                label: 'Which method do you want to do use for the energy step code',
              },
              energyStepCodeToolPart9: {
                label:
                  'Please use this tool to do your fill in your step code details and it will populate onto the application.',
              },
              energyStepCodeReportFile: {
                label: 'BC Energy Step Code Compliance Report',
              },
              energyStepCodeH2000File: {
                label: 'Pre construction Hot2000 model details, Hot2000 report',
              },
            },
          },
          fields: {
            name: 'Name',
            firstNations: 'First Nations',
            description: 'Description',
            associations: 'Associations',
            formFields: 'Form fields',
            updatedAt: 'Updated at',
            requirementSku: 'Requirement SKU',
          },
          configurationsColumn: 'Configurations',
          fieldDescriptions: {
            description: 'Provide some context for admins and managers for this fieldset.',
            associations: 'Assign a tag to help organize and find this requirement block easier.',
            requirementSku: 'Generated unique identifier',
          },
          requirementTypeLabels: {
            text: 'Short text',
            checkbox: 'Checkbox',
            address: 'Address',
            bcaddress: 'BC address',
            geocoderAddress: 'BC address (searchable)',
            date: 'Date',
            number: 'Number',
            textArea: 'Text area',
            radio: 'Radio options',
            multiOptionSelect: 'Multi-select checkboxes',
            select: 'Single select dropdown',
            signature: 'Signature',
            generalContact: 'General contact',
            professionalContact: 'Professional contact',
            file: 'File upload',
            phone: 'Phone',
            email: 'E-mail',
            energyStepCode: 'Energy Step Code',
            stepCodePackageFile: 'Design package file for energy step code',
            pidInfo: 'Pid Info',
            serviceInformation: 'Employee Information',
            utilityAccountNumber: 'Utility Account Number',
            ahriNumber: 'AHRI Number',
          },
          contactFieldItemLabels: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            title: 'Role/Position',
            phone: 'Phone',
            address: 'Address',
            organization: 'Organization',
            businessName: 'Business name',
            businessLicense: 'Business license',
            professionalAssociation: 'Professional association/organization',
            professionalNumber: 'Professional number',
          },
          descriptionMaxLength: '(Max length: 250 characters)',
          unitLabels: {
            option: {
              noUnit: '(no unit)',
              mm: 'mm - millimeters',
              cm: 'cm - centimeters',
              m: 'm - meters',
              in: 'in - inches',
              ft: 'ft - feet',
              mi: 'mi - miles',
              sqm: 'sqm - sq meters',
              sqft: 'sqft - sq feet',
              cad: '$ - CAD',
            },
            display: {
              noUnit: '(no unit)',
              mm: 'millimeters (mm)',
              cm: 'centimeters (cm)',
              m: 'meters (m)',
              in: 'inches (in)',
              ft: 'feet (ft)',
              mi: 'miles (mi)',
              sqm: 'sq meters (sqm)',
              sqft: 'sq feet (sqft)',
              cad: '$ (CAD)',
            },
          },
        },
        formComponents: {
          energyStepCode: {
            edit: 'View and edit compliance report',
            warningFileOutOfDate:
              'Plan file updated may be out of date as it differs from when the step code was created.',
          },
        },
        stepCode: {
          title: 'Step code auto-compliance tool',
          subTitle:
            "You can use this tool to generate your BC Energy Step Code Compliance Report. Approval is not automatic. After you've submitted your application, local officials will review it. They may ask you to fix issues or show that your application meets requirements before approving it.",
          checklistGuide: 'See checklist guide',
          helpLink:
            'https://www2.gov.bc.ca/gov/content/housing-tenancy/building-or-renovating/permits/building-permit-hub/29065',
          helpLinkText: 'What does each step code level mean?',
          saveAndGoBack: 'Save and go back',
          markAsComplete: 'Mark as complete',
          back: 'Back to permit application',
          complete: 'Complete',
          restart: {
            trigger: 'Restart',
            confirm: {
              title: 'Are you sure?',
              body: 'Restarting will clear all checklist fields',
            },
          },
          info: {
            title: 'BC Step Code Compliance Checklist - Part 9 Buildings',
            energy: 'Energy Step Code',
            zeroCarbon: 'Zero Carbon Step Code',
            performancePaths: {
              title: 'For Performance Paths:',
              ers: '9.36.6. BC Energy Step Code ERS',
              necb: '9.36.6. BC Energy Step Code NECB',
              passive: '9.36.6. Passive House',
              stepCode: '9.36.5 BC Energy Step Code',
            },
            more: {
              prompt: 'More details can be found at ',
              link: 'energystepcode.ca',
            },
          },
          drawingsWarning: {
            title: 'Before you start',
            description:
              'Please make sure you have finished uploading all your finalized drawings before generating the report. If you make changes to your uploaded drawings after import, you will need to go through this Step Code Auto-Compliance Tool again.',
          },
          import: {
            title: 'Import',
            selectFile: 'Select .h2k file',
            compliancePath: {
              label: 'BC Building Code Performance Compliance Path:',
              select: 'Select',
              options: {
                step_code_ers: '9.36.6 BC Energy Step Code ERS',
                step_code_necb: '9.36.6 BC Energy Step Code NECB',
                passive_house: '9.36.6 Passive House',
                step_code: '9.36.5 BC Energy Step Code',
              },
            },
            districtEnergyEF: 'District energy EF',
            districtEnergyConsumption: 'District energy consumption',
            otherGhgEf: 'Other GHG EF',
            otherGhgConsumption: 'Other GHG consumption',
            create: 'Create',
            addData: 'Add data',
          },
          index: {
            heading: 'Step Codes',
            newStepCode: 'New step code',
          },
        },
        stepCodeChecklist: {
          pdf: {
            for: 'Step code pre-construction checklist for',
          },
          edit: {
            heading: 'BC Step Code Compliance Checklist - Part 9 Buildings',
            notice: 'Relevant data fields below has been filled in for you by Auto-Compliance.',
            energyStepNotMet:
              'Minimum energy step was not met. Please see <1>F: 9.36.6 Energy Step Code Compliance</1> for details.',
            zeroCarbonStepNotMet:
              'Minimum zero carbon step was not met. Please see <1>G: Zero Carbon Step Code Compliance</1> for details.',
            projectInfo: {
              stages: {
                pre_construction: 'Pre Construction',
                mid_construction: 'Mid Construction',
                as_built: 'As Built',
              },
              heading: 'A: Project Information',
              permitNum: 'Building permit #',
              builder: 'Builder',
              address: 'Project address',
              postalCode: 'Postal code',
              jurisdiction: 'Municipality / District',
              pid: 'PID or legal description',
              buildingType: {
                label: 'Building type',
                placeholder: 'Select',
                options: {
                  laneway: 'Laneway house',
                  single_detached: 'Single detached',
                  double_detached: 'Double/Semi-detached (non-MURB)',
                  row: 'Row house (non-MURB)',
                  multi_plex: 'Multi-plex (non-MURB)',
                  single_detached_with_suite: 'Single detatched w/ secondary suite',
                  low_rise_murb: 'Low-rise MURB',
                  stacked_duplex: 'Stacked duplex (MURB)',
                  triplex: 'Triplex (MURB)',
                  retail: 'Retail',
                  other: 'Other',
                },
              },
              select: 'Select',
              dwellingUnits: 'Number of dwelling units',
            },
            codeComplianceSummary: {
              heading: 'B: Code Compliance Summary',
              required: 'Required',
              notMet: 'not achieved',
              stepRequirement: {
                heading: 'Step Requirements',
                label: 'Please select the energy and zero carbon step combination you are trying to achieve:',
                helpText:
                  'Please reference the <1>step code tool page<2></2></1> for more details and helpful information.',
              },
              compliancePath: {
                label: 'BC Building Code Performance Compliance Path:',
                options: {
                  step_code_ers: '9.36.6 BC Energy Step Code ERS',
                  step_code_necb: '9.36.6 BC Energy Step Code NECB',
                  passive_house: '9.36.6 Passive House',
                  step_code: '9.36.5 BC Energy Step Code',
                },
              },
              energyStepRequired: 'Energy step code required',
              zeroCarbonStepRequired: 'Zero carbon step required',
              notRequired: 'Not Required',
              energyStepCode: {
                heading: 'Energy Step Code',
                stepRequired: 'Step required',
                stepProposed: 'Proposed step achieved',
                steps: {
                  '3': '3',
                  '4': '4',
                  '5': '5',
                },
              },
              zeroCarbonStepCode: {
                heading: 'Zero Carbon Step Code',
                stepRequired: 'Level required',
                stepProposed: 'Proposed step achieved',
                steps: {
                  '1': 'EL 1',
                  '2': 'EL 2',
                  '3': 'EL 3',
                  '4': 'EL 4',
                },
              },
              planInfo: {
                title: 'Based on info provided by the builder & the following drawings:',
                author: 'Plan author',
                version: 'Plan version',
                date: 'Plan date',
              },
            },
            completedBy: {
              heading: 'C: Completed By',
              description:
                'Energy advisors working in teams may designate a contact person for this permit.  This person may or may not be the modeler.  The registration numbers must match the actual modelers registration.',
              energyAdvisor: 'Energy Advisor',
              name: 'Full name',
              date: 'Date',
              company: 'Company name',
              organization: 'Service organization',
              phone: 'Phone',
              energyAdvisorId: 'Energy advisor ID#',
              address: 'Address',
              email: 'Email',
              codeco: 'CODECO placed in Field 8 of H2K',
              yes: 'Yes',
              no: 'No',
              pFile: 'P File #',
            },
            buildingCharacteristicsSummary: {
              heading: 'D: Building Characteristics Summary',
              details: 'Details (assembly / system type / fuel type / etc.)',
              addLine: 'Add line',
              averageRSI: 'Average effective RSI',
              performanceValues: 'Performance values',
              roofCeilings: 'Roof / Ceilings',
              aboveGradeWalls: 'Above grade walls',
              framings: 'Rim Joists / floor headers and lintels',
              unheatedFloors: 'Floors over unheated space',
              belowGradeWalls: 'Walls below grade',
              slabs: 'Slabs',
              windowsGlazedDoors: 'Windows and glazed doors:',
              usi: 'USI',
              u_imp: 'U-Imp',
              shgc: 'SHGC',
              doors: 'Doors:',
              rsi: 'RSI',
              airtightness: 'Air barrier system & location:',
              ach: 'ACH',
              nla: 'NLA',
              nlr: 'NLR',
              spaceHeatingCooling: 'Space heating / cooling:',
              principal: 'Principal:',
              secondary: 'Secondary:',
              afue: 'AFUE',
              hspf: 'HSPF',
              sse: 'SSE',
              cop: 'COP',
              seer: 'SEER',
              hotWater: 'Domestic hot water:',
              percent_eff: '% EFF',
              uef: 'UEF',
              ef: 'EF',
              eer: 'EER',
              ventilation: 'Ventilation',
              litersPerSec: 'L/s',
              other: 'Other',
              fossilFuels: {
                label: 'Fossil fuels',
                no: 'The building including all units is designed with NO fossil fuel use or infrastructure',
                yes: 'The building IS designed to use fossil fuels or has infrastructure for it',
                unknown: 'Fossil fuel use and infrastructure is unknown at this time',
              },
            },
            energyPerformanceCompliance: {
              heading: 'E: Energy Performance Compliance',
              proposedHouseEnergyConsumption: 'Proposed house energy consumption:',
              referenceHouseRatedEnergyTarget: 'Reference house rated energy target:',
              energyUnit: 'GJ/year',
              hvac: 'HVAC',
              dwhHeating: 'DWH Heating',
              sum: 'SUM',
              calculationAirtightness:
                'The airtightness value used in the energy model calculations for the Proposed house is:',
              calculationTestingTarget: 'OR Testing Target',
              compliance: 'The above calculation was performed in compliance with Subsection 9.36.5. of Division B',
              airtightnessValue: {
                select: 'Select',
                options: {
                  two_point_five: '2.5 ACH',
                  three_point_two: '3.2 ACH',
                },
              },
              epcTestingTargetType: {
                select: 'Select',
                options: {
                  ach: 'ACH@50Pa',
                  nla: 'NLA@10Pa',
                  nlr: 'NLR L/s/m2',
                },
              },
            },
            energyStepCodeCompliance: {
              heading: 'F: 9.36.6 Energy Step Code Compliance',
              proposedConsumption: 'Proposed House Rated Energy Consumption',
              refConsumption: 'Reference House Rated Energy Target',
              consumptionUnit: 'GJ/year',
              proposedMetrics: 'Proposed House Metrics',
              requirement: 'Proposed Step Requirement',
              results: 'Proposed House Results',
              passFail: 'Proposed House Pass or Fail',
              step: 'Step Code Level',
              meui: 'Mechanical Energy Use Intensity (MEUI)',
              meuiUnits: {
                numerator: 'kWh',
                denominator: 'm²·yr',
              },
              max: '(max)',
              min: '(min)',
              meuiImprovement: '% Improvement',
              tedi: 'Thermal Energy Demand Intensity (TEDI)',
              tediUnits: {
                numerator: 'kWh',
                denominator: 'm²·yr',
              },
              hlr: '% Heat Loss Reduction',
              ach: 'Airtightness in Air Changes per Hour at 50 Pa differential',
              achUnits: {
                numerator: 'ACH',
                denominator: '@50Pa',
              },
              nla: 'Normalized Leakage Area (NLA₁₀)',
              nlaUnits: {
                numerator: '10 Pa',
                denominator: 'cm²/m²',
              },
              nlr: 'Normalized Leakage Rate (NLR₅₀)',
              nlrUnits: 'L/s/m²',
              requirementsMet: 'Step Code requirements met:',
              otherData: {
                header: 'Other data',
                software: 'Software used',
                softwareVersion: 'Software version',
                heatedFloorArea: 'Heated floor area',
                volume: 'Building volume',
                surfaceArea: 'Building surface area',
                fwdr: 'FWDR',
                climateLocation: 'Climate data (location)',
                hdd: 'Degree Days Below 18°C (HDD)',
                spaceCooled: '% Of Space Cooled',
              },
            },
            zeroCarbonStepCodeCompliance: {
              heading: 'G: Zero Carbon Step Code Compliance',
              proposedMetrics: 'Proposed House Metrics',
              stepRequirement: 'Proposed Step Requirement',
              result: 'Proposed House Result',
              passFail: 'Proposed House Pass or Fail',
              step: 'Zero Carbon Step Code Level',
              max: 'Max',
              min: 'Min',
              ghg: {
                label: 'Total GHG',
                units: {
                  numerator: 'kg CO₂ₑ',
                  denominator: 'yr',
                },
              },
              co2: {
                title: 'CO₂ₑ per floor area with max:',
                perFloorArea: {
                  label: 'CO₂ₑ per floor area',
                  units: {
                    numerator: 'kg CO₂ₑ',
                    denominator: 'm²·yr',
                  },
                },
                max: {
                  label: 'CO₂ₑ max',
                  units: 'kg CO₂ₑ',
                },
              },
              prescriptive: {
                title: 'Prescriptive:',
                heating: 'Heating',
                hotWater: 'Hot water',
                other: 'All building systems, equipment, and appliances',
                zero_carbon: 'zero carbon',
                carbon: 'carbon',
              },
              requirementsMet: 'Target reached:',
            },
            complianceGrid: {
              requirementsMetTag: {
                pass: 'Pass',
                fail: 'Fail',
              },
            },
          },
        },
        home: {
          auditLog: 'Audit Log',
          jurisdictionsTitle: 'Manage programs',
          siteConfigurationTitle: 'Configuration management',
          jurisdictionsDescription:
            'Invite or remove Business Area Managers, Program Managers, PSRs in the Better Homes Energy Savings Program.',
          permitTemplateCatalogueTitle: 'Manage applications templates catalog',
          permitTemplateCatalogueTitleShort: 'Applications catalogue',
          contractorTitle: 'Manage contractor details',
          contractorDescription: 'View and edit contractor details. ',
          contractorProgramResources: 'Contractor program resources',
          submissionInboxSetupTitle: 'Submission inbox set up',
          submissionInboxSetupDescription:
            'Set up your submission inbox and edit who receives submitted application forms.',
          submissionInboxTitle: 'View submissions inbox',
          submissionInboxDescription: 'Review all submitted applications.',
          adminSubmissionInboxDescription: 'View and process all submitted applications.',
          viewSupportedApplicationsTitle: 'View supported applications',
          applicationsDashboardDescription: 'Review applications you have submitted on behalf of an applicant.',
          adminApplicationsDashboardDescription: 'Access applications submitted on behalf of an applicants.',
          startApplicationTitle: 'Start an application',
          startApplicationDescription: 'Submit an application on behalf of a participant. ',
          viewBlankApplicationsTitle: 'View blank applications',
          configureUsersTitle: 'Configure users',
          configureUsersDescription: 'Invite or remove users.',
          apiSettingsTitle: 'API Settings',
          apiSettingsDescription: 'Configure API integrations and settings.',
          reportingTitle: 'Reporting',
          reportingDescription:
            'Explore reports and analytics to gain insights and make informed decisions about your permit applications',
          permitTemplateCatalogueDescription: 'Create and manage application templates for each program.',
          requirementsLibraryTitle: 'Manage requirements library',
          requirementsLibraryDescription:
            'Create and manage requirement blocks that can be used inside of application templates.',
          earlyAccess: {
            title: 'Early access',
            adminDescription:
              'Access and manage Early access previews and requirement sets before they become publicly available.',
            previews: {
              title: 'Early access previews',
              description:
                'View and manage non-submittable permit templates in Early Access, shared with selected users for service design purposes.',
            },
            requirements: {
              title: 'Early access requirements',
              description:
                'Explore and manage pre-release requirement blocks sets designed for testing within Early Access projects.',
            },
          },
          configurationManagement: {
            title: 'Manage configuration',
            reviewManagerDescription:
              "Configure your jurisdiction's operational setup within the Building Permit Hub. Set up your submission inbox, define energy step codes, and edit the 'About' page to reflect specific local information.",
            adminDescription:
              'Manage site-wide settings and messages along with providing administrative control to Super Admins.',
            jurisdictionLocalityTypeLabel: 'Locality type of local jurisdiction',
            jurisdictionNameLabel: 'Name of local jurisdiction',
            jurisdictionLocationLabel: 'Location',
            jurisdictionAbout: {
              title: "My jurisdiction's About page",
              description:
                'Customize the informational page that submitters will see when they are in the Building Permit Hub.',
            },
            submissionsInboxSetup: {
              title: 'Submissions inbox setup',
              description: 'Specify email addresses that should receive applications.',
              permitTypes: {
                label: 'Send permit applications for',
                low_residential: '1-4 Unit detached housing',
                medium_residential: '4+ Unit housing',
                high_residential: 'High density appartment buildings',
                new_construction: 'New construction',
                addition_alteration_renovation: 'Addition, alteration, or renovation',
                site_alteration: 'Site alteration',
                demolition: 'Demolition',
              },
              emailLabel: 'to recipient email(s)',
              addEmail: 'Add another email',
              confirmationRequired: 'Action required: please click link in verification email',
            },
            stepCodeRequirements: {
              title: 'Energy Step Code requirements',
              description: 'Define step code requirements.',
              setMinimum:
                'Set the minimum acceptable levels of Energy Step Code and Zero Carbon Step Code for each permit type below:',
              part9Building: 'Part 9 Building',
              addStep: 'Add another requirement combination',
              deleteCustomization: 'Delete customization',
              overriddenWarning: 'This was overridden by your customized requirements below.',
              notRequired: 'Not required',
              stepRequired: {
                permitTypeHeading: 'PERMIT TYPE',
                standardToPass: 'Standard Step Code compliance to pass',
                customizedMinimum: 'Customized minimum requirement for submission',
                energy: {
                  title: 'Energy Step Code Level',
                  options: {
                    '3': '3',
                    '4': '4',
                    '5': '5',
                  },
                },
                zeroCarbon: {
                  title: 'Zero Carbon Step Code Level',
                  options: {
                    '1': 'EL 1 - Measure Only',
                    '2': 'EL 2 - Moderate',
                    '3': 'EL 3 - Strong',
                    '4': 'EL 4 - Zero Carbon',
                  },
                },
              },
            },
            externalApiKeys: {
              title: 'API settings',
              description: 'Manage API keys for the Building Permit Hub.',
            },
          },
          adminManagerTitle: 'Admin manager portal',
          adminTitle: 'Admin portal',
          superAdminTitle: 'System admin portal',
          systemAdminTitle: 'System admin portal',
          submissionsInboxTitle: 'Submissions inbox',
          submissionsInboxDescription: 'View all submitted building permit applications.',
          permitsTitle: 'Digital building permits',
          permitsDescription:
            'Enhance building permits application process within your local jurisdiction by setting up helpful tips for submitters and selecting elective questions based on your local needs.',
          userManagementTitle: 'User management',
          userManagementDescription: 'Invite or remove Review Managers or Reviewers in the Building Permit Hub.',
          auditLogTitle: 'Audit log',
          stepCodes: 'Step Codes',
        },
        admin: {},
        errors: {
          fetchContractor: 'Something went wrong fetching the contractor',
          fetchJurisdiction: 'Something went wrong fetching the jurisdiction',
          fetchSubmission: 'Something went wrong fetching the submission',
          fetchPermitTypeOptions: 'Something went wrong fetching the permit type options',
          fetchAutoComplianceModuleConfigurations: 'Something went wrong fetching the auto compliance module options',
          fetchActivityOptions: 'Something went wrong fetching the activity options',
          workTypeNotFound: 'Work type not found',
          fetchWorkTypeOptions: 'Something went wrong fetching the work type options',
          fetchRequirementTemplate: 'Something went wrong fetching the requirement template',
          fetchTemplateVersion: 'Something went wrong fetching the template version',
          fetchCurrentUserLicenseAgreements: 'Something went wrong fetching license agreements',
          fetchTemplateVersions: 'Something went wrong fetching template versions',
          fetchBuildingPermits: 'Something went wrong fetching building permits',
          fetchBuildingPermit: 'Something went wrong fetching building permit',
          fetchBuildingPermitJurisdictionChanges: 'Something went wrong fetching building permit jurisdiction changes',
          fetchOptions: 'Something went wrong fetching options',
          fetchJurisdictionTemplateVersionCustomization:
            'Something went wrong fetching jurisdiction template version customization',
          fetchIntegrationMapping: 'Something went wrong fetching jurisdiction integration requirements mapping',
          noResults: 'No results found.',
        },
        user: {
          fields: {
            role: 'Role',
            email: 'Email',
            name: 'Name',
            createdAt: 'Date added',
            lastSignInAt: 'Last signed in',
            action: 'Action',
            submissionInbox: 'Submission inbox',
            addedBy: 'Added by',
            status: 'Status',
          },
          index: {
            tableHeading: 'User accounts',
            inviteButton: 'Invite users',
          },
          menuItems: {
            changeUserRole: 'Change role',
            inboxAccess: 'Submission inbox access',
            removeUser: 'Remove user',
            reinviteUser: 'Re-invite',
            revokeUserInvite: 'Revoke invite',
            reactivateUser: 'Reactivate',
          },
          changeRoleModal: {
            title: 'Change role for',
            selectionLabel: 'Select new role',
            success: 'Role successfully assigned.',
            failure: 'Role has not been assigned.',
          },
          changeInboxModal: {
            title: 'Change application access for',
            selectionLabel: 'Select application access',
            success: 'Submission inbox successfully assigned.',
            failure: 'Submission inbox has not been assigned.',
          },
          changeRole: 'Change role',
          newEmail: 'New email address',
          changeEmail: 'Change email',
          deleteAccount: 'To delete your account, please contact <1>digital.codes.permits@gov.bc.ca</1>.',
          addUser: 'Add more emails',
          invite: 'Invite',
          invitedBy: '<strong>{{email}}</strong> has invited you to join:',
          invitedAsAdmin: '<strong>{{email}}</strong> has invited you to join {{program}} as a {{role}}',
          invitedAs: 'as a',
          invitationIntent:
            'This invitation is intended for <strong>{{email}}</strong>, if this is incorrect please contact the sender above.',
          invalidInvitationToken: {
            message:
              'If you have any questions, please ask your primary contact to call us at 1-833-856-0333 or email us at:',
            mailTo: 'ESPcontractorSupport@CLEAResult.com',
            expired: {
              title: 'Expired Invitation',
              adminBody: 'Contact your manager to re-issue the invite.',
              cta: 'Back to Contractor homepage',
            },
            consumed: {
              title: 'Someone already used this link.',
              body1: 'Someone from your company has already transferred this account to the new portal.',
              body2:
                "If you're an employee who needs access, reach out to your company's primary contact for the account. They can request your access from within the portal.",
            },
            contact: {
              heading: "Your company's primary contact can reach out if you need help:",
              phone: '1-833-856-0333',
              email: 'ESPcontractorSupport@CLEAResult.com',
            },
          },
          createAccount: 'Proceed with your account creation',
          omniauthProviders: {
            idir: 'IDIR',
            bceidbasic: 'Basic BCeID',
            bceidbusiness: 'Business BCeID',
            bcsc: 'BCSC',
          },
          changeIdir: {
            descriptionParts: [
              {
                type: 'text',
                content:
                  'If your IDIR details are incorrect, please contact your business area or program administrator to request an update.',
              },
            ],
          },
          changeBasic: {
            descriptionParts: [
              {
                type: 'text',
                content: 'The information above is from your Basic BCeID account. You can ',
              },
              {
                type: 'link',
                content: {
                  text: 'change your Basic BCeID account information',
                  href: 'https://www.bceid.ca/aboutbceid/faqs.aspx',
                },
              },
              { type: 'text', content: '.' },
            ],
          },
          changeBcsc: {
            descriptionParts: [
              {
                type: 'text',
                content: 'The information above is from your BC Services account. You can ',
              },
              {
                type: 'link',
                content: {
                  text: 'change your BC Services Card information',
                  href: 'https://www2.gov.bc.ca/gov/content/governments/government-id/bc-services-card/your-card/change-personal-information',
                },
              },
              { type: 'text', content: '.' },
            ],
          },
          changePrimaryContact: {
            descriptionParts: [
              {
                type: 'text',
                content:
                  'This information is from your Business BCeID Account. We will use this email address for communication. ',
              },
              {
                type: 'link',
                content: { text: 'Manage your Business BCeID Account', href: 'https://www.bceid.ca/' },
              },
              { type: 'text', content: '.' },
            ],
          },
          //changeBceid: 'If you want to change your BCeID information, please go to ',
          //changeBceidLinkText: 'bceid.ca',
          confirmationRequiredWithEmail:
            'Action required: please click the link in the verification email that was sent to you. You will continue to receive emails at <strong>{{email}}</strong> until your new email is confirmed. <br/><br/>(Didn’t receive it? <1>Resend email</1>)',
          confirmationRequired:
            "Action required: please click the link in the verification email that was sent to you. <br/><br/>(Didn't receive it? <1>Resend email</1>)",
          receiveNotifications: 'Receive notifications',
          notificationsEmail: 'Notification email address',
          firstName: 'First name',
          lastName: 'Last name',
          userName: 'User name',
          address: 'Address',
          mailingAdress: 'Street address or PO Box',
          city: 'City',
          province: 'Province',
          postalCode: 'Postal code',
          country: 'Country',
          sameAddress: 'My residential address is the same as my mailing address',
          postalAddress: 'Mailing address',
          required: 'required',
          emailAddress: 'Email address',
          myProfile: 'My profile',
          myAccount: 'My account',
          accountCreation: 'Create account',
          termsandConditions: 'Terms and conditions',
          acceptedConditions: 'You accepted the terms and conditions on {{date}} at {{time}}',
          emailValidationError: 'You need to have at least one email address to receive notifications.',
          enterValidEmail: 'Please enter a valid email address',
          inviteTitle: 'Invite users',
          adminInviteTitle: 'Invite super admins',
          inviteSuccess: 'Invite sent!',
          reinvite: 'Re-invite',
          reinviteSuccess: 'User already exists in the system and has been successfully assigned to this program',
          contractorReinviteSuccess: 'Invite re-sent successfully',
          inviteError: 'Email taken',
          contractorPendingError: 'This user has already been invited',
          contractorDeactivatedError: 'This user has been deactivated in this contractor',
          takenErrorTitle: 'Some of these emails already belong to existing users',
          takenErrorDescription: '',
          sendInvites: 'Send invites',
          inviteSentSuccess: '{{count}} invite(s) sent successfully.',
          inviteCheckErrors: 'Please check the errors below and correct them before sending invites.',
          inviteAlreadyActive: 'This user is already active in this program.',
          inviteAlreadyDeactivated: 'This user has been deactivated in this program.',
          acceptInvitation: 'Accept invitation',
          acceptInstructions: 'Enter your login and other user info below to finalize your account creation.',
          rolesAndPermissions: 'User roles & permissions',
          inviteInstructions:
            'Enter the email addresses of whom you wish to invite below. For details about permissions for each role, please see <a>User Roles & Permissions</a>',
          inviteEmployeesTitle: 'Invite employees',
          inviteEmployeesDescription:
            'Enter the email address of the employee to invite. They will receive a link through their email to create an account using their Business BCeID.',
          addMoreEmails: 'Add more emails',
          notifications: {
            essential: 'Essential communications (cannot disable)',
            event: 'Event',
            enableNotification: 'Enable notification',
            templateChanged: 'Changes to permit requirements',
            templateCustomized: 'Jurisdiction customizations to permit requirements',
            applicationSubmitted: 'Application submitted to jurisdiction',
            applicationViewed: 'Application viewed by jurisdiction',
            applicationRevisionsRequested: 'Revisions requested by jurisdiction',
            collaboration: 'Collaboration',
            integrationMapping: 'API integration mapping',
          },
          emailConfirmed: {
            heading: 'Email confirmed!',
            description: 'You will receive updates and notifications at the confirmed email address.',
          },
          inApp: 'In-App',
          email: 'Email',
          // Leave in snake case so we can use: t(`user.roles.${role}`)
          roles: {
            submitter: 'submitter',
            regional_review_manager: 'regional review manager',
            review_manager: 'review manager',
            reviewer: 'reviewer',
            super_admin: 'super admin',
            participant: 'participant',
            admin: 'Admin',
            contractor: 'contractor',
            admin_manager: 'Admin manager',
            system_admin: 'System admin',
          },
          rolesExplanation: {
            submitter:
              'The Submitter is typically an external user, such as a contractor, homeowner, or architect,' +
              ' who initiates the building permit application process. They are responsible for providing all necessary documentation and information required for the permit application. Submitters need to ensure their submissions are complete, accurate, and comply with local regulations.',
            review_manager:
              "The Review Manager supervises the Reviewers and the entire building permit review operation. In addition to possessing all the permissions of a Reviewer, Review Managers are tasked with administrative oversight. Their responsibilities include the distribution of work among Reviewers, maintaining efficiency and consistency in the review processes, and ensuring that the quality of service meets established standards. Moreover, Review Managers have extended privileges to modify local government-specific configurations within the building permit application system, such as updating Step Code requirements, managing content on the 'About' page, and other application settings pertinent to their jurisdictional needs.",
            reviewer:
              'A Reviewer is typically an employee within the local government or a designated authority responsible for examining building permit applications submitted by the Submitter. Reviewers assess the documentation for compliance with building codes, zoning laws, and other regulatory requirements. They may request additional information, approve, reject, or provide comments on the applications.',
            super_admin:
              'The Super Admin is the highest-level user within the system, with overarching control over the entire permit application platform. They have the authority to manage user roles, including creating and removing user accounts, and to modify the system configuration. This role is responsible for the maintenance of the system, including updates and enhancements, and ensuring that the system meets the operational and strategic objectives of the local government or the organization.',
          },
          assignTo: 'Assign to...',
        },
        earlyAccessRequirementTemplate: {
          show: {},
          index: {
            tableHeading: 'Previews',
            title: 'Early access templates catalogue',
            invitationInfo:
              'Early access previews are non-submittable and accessible only by registered users who are invited. Access is granted for 60 days and can be extended or revoked at any time.',
            createButton: 'Create new early access template',
            seeArchivedButton: 'See archived',
            sharePreviewLink: 'Share ({{ n }})',
            sharePreviewTitle: 'Share preview',
            inviteToPreviewTitle: 'Invite to preview',
            inviteToPreviewHint: 'Separate each email with a comma ,',
            revokeButton: 'Revoke',
            unrevokeButton: 'Unevoke',
            extendButton: 'Extend',
            inviteToPreviewButton: 'Send invites',
            noPreviewersYet: 'No previewers yet. Click invite to add previewers to this template',
            inviteToPreviewPartialSuccess: 'Some invites failed to send',

            confirmation: {
              revokeTitle: 'Are you sure you want to revoke access for {{ name }}?',
              revokeBody:
                'Revoking access will immediately prevent this user from accessing the early access content. This may be undone.',
              extendTitle: 'Extend Access Duration for {{ name }}',
              extendBody:
                'Extending access will give the user 60 additional days to interact with the early access content. Do you want to proceed?',
              unrevokeTitle: 'Restore Access for {{ name }}',
              unrevokeBody:
                'Restoring access will allow the user to access the early access content again. Are you sure you want to proceed?',
            },
          },
          new: {
            title: 'Create new preview',
            modalTitle: 'Create new preview',
            startingFresh: 'Starting fresh?',
            addFromExisitng: 'Add requirements from an exisitng permit?',
            startWithBlank: 'Start with blank permit',
            copyFromLive: 'Copy from live permit',
            copyFromThis: 'Copy from this',
          },
          edit: {
            lastFetched: 'Last fetched',
            fetchLatest: 'Fetch latest',
            auditLog: 'Audit log',
            confirmRemoveModalTitle: 'Archive preview?',
            confirmRemoveModalBody: 'This preview will no longer be accessible by invitees',
            public: 'Grant public access?',
          },
          fields: {
            nickname: 'Nickname',
            permitType: 'Permit type',
            activity: 'Work type',
            firstNations: 'First nations?',
            sharedWith: 'Shared with',
            updatedAt: 'Updated at',
            assignee: 'Assigned',
          },
        },
        requirementTemplate: {
          compareAction: 'Requirement "{{ requirementName }}" has been {{ action }}',
          changed: 'changed',
          added: 'added',
          removed: 'removed',
          edit: {
            requirementsLibraryTab: 'Requirements Library',
            earlyAccessRequirementsLibraryTab: 'Early Access Requirements Library',
            earlyAccessTabDescription: "Early access previews cannot add 'Exclude preview' blocks ",
            options: {
              button: 'Options',
              copyTips: 'Import tips from ({{ templateLabel }})',
              copyElectives: 'Import electives from ({{ templateLabel }})',
            },
            promoteElectives: 'Export changes',
            promoteElectivesMessage:
              'This will publish your sandboxed customizations and overwrite your non-sandboxed live electives!',
            clickToWriteDescription: 'Click to write description',
            title: '',
            dndTitle: 'Drag to reorder',
            dndInstructions:
              "Change the order of requirements by using the menu on the left to drag items up or down. Click the 'Done' button to return to the form.",
            addSectionButton: 'Add section',
            addRequirementButton: 'Add requirement',
            saveDraft: 'Save as draft',
            closeEditor: 'Close editor',
            sectionsSidebarTitle: 'Contents',
            reorderButton: 'Reorder',
            removeConfirmationModal: {
              title: 'Are you sure you want to remove this section?',
              body: 'Any requirements inside this section will also be removed along with it.',
            },
            emptyTemplateSectionText: 'Start by clicking the Add Section button',
            stepCodeWarnings: {
              energyStepCodeRecommended:
                'Warning:"Design package energy step code file" is present in the template, but there is no "Energy step code" requirement.',

              duplicateStepCodePackage:
                'Warning: Multiple "Design package energy step code files" found. Please ensure there is only one "Design package energy step code file".',
            },
            stepCodeErrors: {
              duplicateEnergyStepCode:
                'Warning: Multiple "Energy step code" requirements found. Please ensure there is only one "Energy step code" in the template.',
              stepCodePackageRequired:
                'Warning: "Energy step code" is required to have the "Design package energy step code file".',
              duplicateStepCodePackage:
                'Multiple "Design package energy step code files" found. Please ensure there is only one "Design package energy step code file" when there is an "Energy step code" requirement',
            },
            goToTop: 'Go to top',
            collapseAll: 'Collapse all',
            scheduleModalTitle: 'Publish permit?',
            scheduleModalBody:
              'Once you publish, local jurisdictions and submitters will be able to see and use this new version of the form.',
            scheduleModalHelperText: 'Schedule to <1>publish</1> (at midnight 00:01 PST)',
            scheduleModalCancelMessage: 'Changes were not scheduled.',
            forcePublishNow: 'Force publish!',
            pleaseReview: 'Please review the following:',
            errorsBox: {
              title: 'There are {{count}} fields with errors on the page',
              instructions: 'Please fix the following before submitting:',
            },
            diffBox: {
              title: 'Template changes',
              instructions: 'Please review the following:',
              added: 'Added',
              changed: 'Changed',
              removed: 'Removed',
              updateToNewVersion: 'See new',
            },
            duplicateRequirementBlockDisabledReason: 'This requirement block is already in the template',
            goToLatest: 'Go to latest',
          },
          fields: {
            status: 'Status',
            nickname: 'Template name',
            activity: 'Work type',
            userGroupTypeSelect: 'Select a user group for this template*',
            audienceTypeSelect: 'Select the audience for this program*',
            submissionTypeSelect: 'Select the submission type*',
            submissionSubTypeSelect: 'Select the submission subtype*',
            audienceType: 'Audience',
            submissionType: 'Submission type',
            userGroupType: 'User group',
            firstNations: 'First Nations',
            description: 'Description',
            currentVersion: 'Current version',
            program: 'Program',
            actions: 'Actions',
          },
          status: {
            published: 'Published',
            scheduled: 'Scheduled',
            draft: 'Draft',
            deprecated: 'Deprecated',
          },

          index: {
            tableHeading: 'Templates',
            title: 'Applications template catalog',
            description:
              'List of all application in the system that’s been created by the Admin manager or a System admin. Only Published application will be visible to programs.',
            createButton: 'Create a new template',
            seeArchivedButton: 'See archived',
          },
          new: {
            title: 'Create a new template',
            typePrompt: 'What kind of building permit is this?',
            descriptionHelpText: '(Max 250 Characters)',
            createButton: 'Create template',
            firstNationsLand: 'This permit is intended only for <1>First Nation Registered Land</1>',
            copyExistingByClassifications: 'Copy from existing template of this permit and work type if available',
            programQuestion: 'Select a program for this template*',
            applicationName: 'What is the name of this template?* ',
          },
          versionSidebar: {
            triggerButton: 'Versions',
            title: 'Template versions',
            subtitlePrefix: 'For:',
            viewTemplateButton: 'View template',
            resumeDraftButton: 'Resume draft',
            unscheduleButton: 'Unschedule',
            listTitles: {
              published: 'Published',
              draft: 'Drafts',
              scheduled: 'Scheduled',
              deprecated: 'Deprecated (last 3)',
            },
            unscheduleWarning: {
              title: 'Are you sure you want to unschedule this template?',
              body: 'This action cannot be undone.',
            },
            deprecationReasonLabels: {
              unscheduled: 'reason: unscheduled',
              new_publish: 'reason: new publish',
            },
            lastUpdated: 'Last updated',
          },
          export: {
            title: 'Export Templates',
            downloadSummaryCsv: 'Download Summary CSV',
            templateSummaryFilename: 'Template Summary',
            downloadCustomizationCsv: 'Download Customizations CSV',
            downloadCustomizationJson: 'Download Customizations JSON',
          },
        },
        apiMappingsSetup: {
          title: 'API mappings setup',
          index: {
            helperSubtitle: 'See details of how fields are mapped to the API.',
            seeButton: 'See {{status}}',
          },
          edit: {
            permitTemplate: 'Template',
            seeApiDoc: 'See API documentation',
            heading: '<1>Manage mapping for</1> <2>{{permitClassification}}</2>',
            table: {
              blockAccordionButton: '{{blockName}} <1>requirement block code: {{blockCode}}</1>',
              filter: {
                showAll: 'Show all',
                showOnlyUnmapped: 'Show only unmapped',
              },
              title: 'API mappings',
              headers: {
                localField: 'Your local field name',
                localFieldInfo: 'Local field mapping info',
                templateField: 'Map to <1>requirement code</1> in template',
                requirementDetail: 'Field in template',
              },
              localFieldEdit: {
                addMapping: 'Add local mapping',
                addMappingLabel: 'Local mapping',
              },
            },
          },
        },
        digitalBuildingPermits: {
          index: {
            title: 'Digital Building Permits',
            selectPermit: 'Select a digital permit:',
            workType: 'Work type',
            manageButton: 'Manage',
            lastUpdated: 'Last updated',
            requestNewPromptWithLink:
              'Your administrator has made the above permit types available for digital submissions. If there is another permit type you want please <1>request a new permit type</1>.',
            emptyPermitsText:
              'No available building permits of the selected work type. Please wait for updates from the Ministry of Housing.',
          },
          edit: {
            requirementBlockSidebar: {
              description:
                'Local jurisdictions can change building permit applications to fit their needs by adding elective fields and offering submitters practical tips. This helps make the application forms reflect the distinct regulations, standards, and requirements of each jurisdiction, so applicants provide the correct information needed by their area.',
              tipLabel: 'Tip for submitters (optional)',
              filterLabel: 'Search electives',
              sortLabel: 'Sort by',
              filterPlaceholder: 'Search electives',
              sortOptions: {
                labelAsc: 'Elective (A-Z)',
                labelDesc: 'Elective (Z-A)',
                reasonAsc: 'Reason (A-Z)',
                reasonDesc: 'Reason (Z-A)',
              },
              manageFieldsButton: 'Manage elective field(s)',
              resetToDefaults: 'Reset to defaults',
              selectFieldsTitle: 'Select elective fields',
              electiveFormFields: 'Elective form fields',
              addSelectedButton: 'Add selected',
              reason: 'Reason:',
              reasonLabels: {
                placeholder: 'Select a reason',
                bylaw: 'Bylaw',
                zoning: 'Zoning',
                policy: 'Policy',
              },
            },
          },
        },
        siteConfiguration: {
          title: 'Site configuration management',
          adminUserIndex: {
            title: 'Users',
            description: 'View and manage system administrative users',
          },
          landingPageSetup: {
            title: 'Landing page setup',
            description: 'Configure content for the landing page',
            selectOpenAccessPreviews:
              'Set open access previews to display on the front page. Select from the available public access previews below.',
            smallScale: 'Set as Small Scale New Contruction Preview on landing page',
            fourPlus: 'Set as Four Plus New Construction Preview',
          },
          sitewideMessage: {
            title: 'Site-wide banner',
            description: 'Enable and configure a site-wide message',
            enable: 'Show',
            label: 'Text for banner',
            hint: 'This banner text will appear at the top of all pages.',
            settings: 'Settings',
            colorLabel: 'Banner type',
            colors: {
              lightYellow: 'Minor issue (yellow)',
              red: 'Major issue (red)',
              blue: 'Information (blue)',
            },
          },
          revisionReasonsAttributesSetup: {
            title: 'Update reasons',
            description: 'Setup reasons for updates',
            options: 'Selectable options',
            fields: {
              reasonCode: 'Reason code',
              reasonDescription: 'Reason description',
              descriptionHint: 'A short descriptor for the reason',
            },
          },
          helpDrawerSetup: {
            title: 'Help drawer setup',
            description: 'This function will be launched soon.',
            settings: 'Links',
            fields: {
              show: 'Show',
              title: 'Title',
              href: 'CMS Lite GUID Link Url',
              description: 'Description',
              titleHint: 'Text for the main call-to-action',
              descriptionHint: 'Short description below to give context',
            },
            getStartedLinkItem: {
              label: 'Get started',
            },
            bestPracticesLinkItem: {
              label: 'Best practices',
            },
            dictionaryLinkItem: {
              label: 'Dictionary of terms',
            },
            userGuideLinkItem: {
              label: 'User and role guide',
            },
          },
        },

        reporting: {
          title: 'Reporting',
          tableHeading: 'Available reports',
          filterPlaceholder: 'Filter reports by name',
          stepCodeSummaryName: 'Energy step code configuration by jurisdiction',
          stepCodeSummaryDescription: 'Energy step code configuration by jurisdiction',
          templateSummary: {
            name: 'Template summary',
            description: 'A summary of template usage by jurisdictions',
            title: 'Export Template Summary',
          },
          stepCodeSummary: {
            name: 'Energy step code configuration by jurisdiction',
            description: 'A summary of step code requirements by jurisdictions',
            title: 'Export energy step code configuration by jurisdiction',
            filename: 'Energy step code configuration by jurisdiction',
          },
          applicationMetrics: {
            name: 'Basic Application metrics for all jurisdictions',
            description:
              'Submitted and draft application metrics by jurisdiction and type, excluding submissions created by employee accounts',
            title: 'Basic Application metrics for all jurisdictions',
            filename: 'Basic Application metrics for all jurisdictions',
          },
          columnHeaders: {
            name: 'Name',
            description: 'Description',
          },
        },
        externalApiKey: {
          index: {
            createExternalApiKey: 'Create new API key',
            enabled: 'Enabled',
            disabled: 'Disabled',
            accessDocs: 'Access the API Documentation',
            table: {
              heading: 'API keys',
            },
            apiKeyInfo: {
              title: 'Generate API Keys for Third-Party Integrators',
              body: 'Use this screen to generate API keys for third-party integrations. For technical details on using the API, refer to our documentation site.<1>Access the API Documentation</1> Share the above link with developers or technical team members needing detailed integration information.',
            },
            disabledWarningTitle:
              'API keys for this jurisdiction have not been enabled. To enable them, please contact' + ' us at',
            disabledTooltipLabel: 'User is not authorized to make this change',
            disableConfirmationModal: {
              title: 'Are you sure you want to disable API keys for this jurisdiction?',
              body: 'All active API keys will be disabled',
            },
          },
          modal: {
            createTitle: 'Create API key',
            manageTitle: 'Manage API key',
            removeConfirmationModal: {
              title: 'Are you sure you want to revoke this API key?',
              body: 'Any applications using this token will be unable to access the API.',
            },
          },
          fieldLabels: {
            name: 'Name',
            connectingApplication: 'Application connecting to',
            revokedAt: 'Revoked at',
            webhookUrl: 'Webhook URL',
            expiredAt: 'Expires on',
            createdAt: 'Created at',
            token: 'Token',
            status: 'Status',
            notificationEmail: 'Notification email',
            sandbox: 'Sandbox',
          },
          notificationEmailHint:
            'This email will be used to notify your local integration partner about upcoming changes to API mappings. Note: Jurisdiction review managers will be notified via their registered email irrespective of this field',
          fieldPlaceholders: {
            webhookUrl: 'https://example.com/webhook',
          },
          status: {
            active: 'Active',
            notActive: 'Not-Active',
          },
        },
        site: {
          title: 'Better Homes Energy Savings Program application',
          titleLong: 'Better Homes Energy Savings Program',
          adminNavBarTitle: 'Better Homes Energy Savings Program',
          adminPanel: 'Admin Panel',
          beta: 'Beta',
          linkHome: 'Navigate home',
          didYouFind: 'Did you find what you were looking for?',
          thankYouForResponse: 'Thank you for your response!',
          actionRequired: {
            application_revisions_request:
              'We need more information to continue processing your application <1 />. Your place in the queue is secure, but we cannot process your application until updates are made.',
          },
          govFeedbackResponseNoReasons: {
            unclear: 'This information is unclear',
            missingInfo: 'This page is missing the information I need',
            notRelated: 'This page is not related to what I searched for',
            other: 'Other',
          },
          helpDrawer: {
            phoneTitle: 'Telephone',
            phoneHours: '9 am - 5 pm, Monday - Friday',
            phoneHoursNote: '(excluding statutory holidays).',
            emailTitle: 'Email',
            emailAddress: 'BetterHomesESP@CLEAResult.com',
            contractorEmail: 'ESPcontractorSupport@CLEAResult.com',
            contractorEmailAriaLabel: 'Email us at ESPcontractorSupport@CLEAResult.com.',
            groundOrientedTitle: 'Ground-oriented home types',
            groundOrientedEmail: 'BetterHomesESP@CLEAResult.com',
            groundOrientedEmailAriaLabel: 'Email us about ground-oriented home types at BetterHomesESP@CLEAResult.com',
            multiUnitTitle: 'Multi-unit home types',
            multiUnitEmail: 'ESPcondoapartment@CLEAResult.com',
            multiUnitEmailAriaLabel: 'Email us about multi-unit home types at ESPcondoapartment@CLEAResult.com',
            singleFamilyHome: 'Single family home',
            secondarySuite: 'Secondary suite in a single family home',
            duplexTriplex: 'Duplex, triplex, 4-5 unit multiplex',
            rowTownhome: 'Row or side-by-side townhome',
            manufacturedHome: 'Manufactured / mobile home',
            apartmentCondo: 'Apartment, condo and mixed unit buildings',
            stackedTownhouse: 'Stacked townhouse building',
            multiplexes: 'Multiplexes with 6 or more units',
          },
          support: {
            getSupport: 'Get support',
            contactAt: 'Contact us at',
            contactTeamCTA: 'BetterHomesESP@CLEAResult.com',
            contactUs: 'or 1-833-856-0333 from 9 am - 5 pm, Monday - Friday (excluding statutory holidays).',
            hereToHelp: "We're here to help",
            speakWithEnergyCoach: 'Speak with an Energy Coach',
            anyQuestions:
              'Do you have questions about the program or home upgrade opportunities? Energy Coaches can help you understand home energy upgrades and rebates. Request a call from an Energy Coach for help or to register for the Savings Program by phone. Calls take about 20 minutes.',
            bookACall: 'Book a call',
            learnMore: 'Learn more about the Energy Savings Program',
            offers:
              "The Better Homes Energy Savings Program offers income-based rebates on home energy upgrades. It's part the Province of B.C.'s CleanBC program. Learn more about program eligibility and the home energy rebates that are offered on",
            betterHomes: 'Better Homes',
            emailAriaLabel: 'Email us at BetterHomesESP@CLEAResult.com',
            applicationHelpTitle: 'Get help with your Energy Savings Program application',
            applicationHelpDescription:
              'Do you have questions about your application, the program or home upgrade opportunities? We can help you understand home energy upgrades and rebates. Calls usually take about 20 minutes.',
            applicationHelpContactPrefix: 'Contact us at',
            applicationHelpContactSuffix:
              'or 1-833-856-0333 from 9 am - 5 pm, Monday - Friday (excluding statutory holidays).',
            personalizedAdviceTitle: 'Get personalized upgrade advice',
            personalizedAdviceDescription:
              "For the highest level of support, an energy specialist can do a virtual walk-through of your home to provide advice on what upgrades are right for you. They'll also help you apply for ESP. Virtual assessments take about 60 minutes.",
            bookAssessmentAriaLabel: 'Book a virtual energy assessment with a specialist (opens in new window)',
            bookAssessmentButton: 'Book a virtual assessment',
            learnMoreTitle: 'Learn more about the Energy Savings Program',
            learnMoreDescription:
              "The Better Homes Energy Savings Program offers income-based rebates on home energy upgrades. It's part of the Province of B.C.'s CleanBC program. Learn more about program eligibility and the home energy rebates that are offered on",
            betterHomesLinkAriaLabel: 'Learn more about Better Homes Energy Savings Program (opens in new window)',
            betterHomesLinkText: 'Better Homes.',
            contactInfo:
              'Contact us at 1-833-856-0333 from 9 am - 5 pm, Monday - Friday (excluding statutory holidays).',
            applicationHelpTitleShort: 'Get help with your Energy Savings Program application',
            applicationHelpDescriptionShort:
              'Do you have questions about your application, the program or home upgrade opportunities? We can help you understand home energy upgrades and rebates by email, or you can',
            applicationHelpCallLink: 'schedule a call with an Energy Savings Program Specialist',
            applicationHelpCallUrl:
              'https://submit.digital.gov.bc.ca/app/form/submit?f=a216ecd7-c840-457a-9f8f-b350f334849b',
            applicationHelpDescriptionEnd: '.',
            // applicationHelpDescriptionShort:
            //   "We can help you understand home energy upgrades and rebates by email or phone. Job action means we can't currently schedule calls with Energy Savings Program Specialists: please phone us instead.",
            groundOrientedEmail: 'BetterHomesESP@CLEAResult.com',
            multiUnitEmail: 'ESPcondoapartment@CLEAResult.com',
            contractorEmail: 'ESPcontractorSupport@CLEAResult.com',
            groundOrientedLabel: 'Single family dwellings, rowhouses and other ground-oriented home types:',
            multiUnitLabel: 'Condo, apartment and other multi-unit home types:',
            contractorLabel: 'Support for contractors:',
            learnMoreTitleShort: 'Learn more about the Energy Savings Program',
            learnMoreDescriptionShort:
              "The Better Homes Energy Savings Program offers income-based rebates on home energy upgrades. It's part of the Province of B.C.'s CleanBC program. Learn more about program eligibility and the home energy rebates that are offered on",
            betterHomesLinkTextShort: 'Better Homes',
            contractorSupportEmail: 'ESPcontractorSupport@CLEAResult.com',
          },
          territorialAcknowledgement:
            'The B.C. Public Service acknowledges the territories of First Nations around B.C. and is grateful to carry out our work on these lands. We acknowledge these rights, interests, priorities, and concerns of all Indigenous Peoples - First Nations, Métis, and Inuit - respecting and acknowledging their distinct cultures, histories, rights, laws, and governments.',
          // privacyAndTermsPrefix: "This site is protected by reCAPTCHA and the Google",
          // midText: "and",
          // privacyText: "Privacy Policy",
          // termsText: "Terms of Service",
          privacyAndTermsSuffix: 'apply.',
          home: 'Home',
          contact: 'Contact us',
          betterHomes: 'Better Homes',
          disclaimer: 'Disclaimer',
          dataAndPrivacy: 'Data and privacy',
          footerLinks: {
            betterHomes: 'https://www.betterhomesbc.ca/',
            disclaimer: 'https://www2.gov.bc.ca/gov/content/home/disclaimer',
            accessibility: 'https://www2.gov.bc.ca/gov/content/home/accessible-government',
            copyright: 'https://www2.gov.bc.ca/gov/content/home/copyright',
            dataAndPrivacy: 'https://www2.gov.bc.ca/gov/content/home/privacy',
          },
          contactEmail: 'betterhomesbc@gov.bc.ca',
          contactInstructions_1: 'If you have any questions or need assistance, see the contact options below:',
          contactInstructions_2: 'Have a question about your digital permit application?',
          contactInstructions_3:
            'Please contact your local jurisdiction for questions related to your permit application.',
          contactTeamInstructionsTitle: 'Contact the Building Permit Hub Team',
          contactTeamInstructions: [
            'Do you have some feedback for the Building Permit Hub Team?',
            'Do you have any questions or need assistance regarding your experience using the Building Permit Hub?',
          ],
          contactTeamCTA: 'Please contact us at',
          contactNeedHelp: 'Need general help?',
          contactNeedHelpInstructions:
            'Services are available in a variety of different languages and channels through Service BC.',
          contactNeedHelpCTA: 'Get help with government services',
          listJurisdictions: 'See list of jurisdictions',
          help: 'Help',
          aboutTitle: 'About',
          disclaimerTitle: 'Disclaimer',
          copyrightHolder: 'Government of British Columbia.',
          metaDescription:
            'The Building Permit Hub helps you submit a building permit application through a streamlined and standardized approach across jurisdictions in B.C. This tool connects you with local government and First Nation information to support the building permit submission process.',
          metaKeywords: 'BC, british columba, permit, portal, hub, permitting, permit application',
          loggedInWelcome: 'Welcome back!',
          myApplications: 'My applications',
          myPermits: 'My permits',
          newApplication: 'Start an application',
          activePermits: 'Active permits',
          approvedPermits: 'Approved permits',
          myAccount: 'My Account',
          giveFeedback: 'Give feedback',
          error: 'Something went wrong, please try refreshing the page',
          menu: 'Menu',
          menuClose: 'Close menu',
          menuOpen: 'Open menu',
          mainNavigation: 'Main navigation',
          newApplicationLabel: 'Start a new application',
          reviewNotifications: 'Review notifications',
          reviewNotificationsLabel: 'Review all notifications',
          somethingWrong: 'Something went wrong',
          pageNotFound: 'Oops, we can’t find that page',
          pageNotFoundInstructions:
            'The page you’re looking for might have been removed, moved, or is temporarily unavailable.',
          pageNotFoundWeSuggest: 'We suggest',
          pageNotFoundChecking: 'Checking that the web URL has been entered correctly',
          pageNotFoundGoing: 'Going to the ',
          pageNotFoundGoHome: 'Energy Savings Program application home page',
          pageNotFoundReaching: 'Reaching out to ',
          pageNotFoundGetSupport: 'Get support',
          pageNotFoundCTA: 'Go back to home',
          pageNotFoundContactInstructions: 'Do you believe this to be in error or are you stuck?',
          seeConsoleForDetails: 'See the browser console for details',
          accessibility: 'Accessibility',
          copyright: 'Copyright',
          formSupportContact: 'If you have questions or need support with this form please contact us:',
          foippaWarning:
            'We are collecting your personal information under section 26(c) & (e) of the Freedom of Information and Protection of Privacy Act. We are collecting this information to process your application to the CleanBC Better Homes Energy Savings Program, and for program planning and evaluation. The Ministry of Energy and Climate Solutions administers this program. If you have questions about the collection of your information, please contact us at {{email}}. ',
          pleaseContact:
            'Please contact your local government for questions related to your energy savings application.',
          forHelp: 'For help with the Building Permit Hub please contact:',
          breadcrumb: {
            latest: 'Latest',
            profile: 'Edit My account',
            jurisdictions: 'Jurisdictions',
            new: 'New',
            newTemplate: 'Create a new template',
            newProgram: 'Create new program',
            programs: 'Programs',
            configureUsers: 'Configure users',
            invite: 'Invite',
            inviteEmployee: 'Invite employees',
            templateVersions: 'Template versions',
            requirementsLibrary: 'Requirements library',
            requirementTemplates: 'Applications template catalog',
            edit: 'Edit program',
            users: 'Users',
            contractorManagement: 'Manage contractor details',
            suspend: 'Suspend contractor',
            reason: 'Reason for suspension',
            confirmation: 'Contractor suspended',
            unsuspendConfirmation: 'Contractor unsuspended',
            remove: 'Remove contractor',
            removalReason: 'Reason for removal',
            removalConfirmation: 'Contractor removed',
            contractorProgramResources: 'Contractor program resources',
            employees: 'View employees',
            editTemplate: 'Edit template',
            editPermit: 'Edit permit',
            applications: 'Applications',
            supportedApplications: 'View supported applications',
            blankApplications: 'View blank applications',
            newApplication: 'Start an application',
            newInvoice: 'Select invoice type',
            submissionInbox: 'Submissions inbox',
            configuration: 'Configure jurisdiction',
            sucessfulSubmission: 'Application submitted',
            stepCodes: 'Step Codes',
            digitalBuildingPermits: 'Digital building permits',
            contact: 'Contact us',
            configurationManagement: 'Configuration management',
            auditLog: 'Audit log',
            energyStep: 'Energy Step Code requirements',
            submissionsInboxSetup: 'Submissions inbox setup',
            confirmed: 'E-mail confirmed',
            welcome: 'Welcome',
            contractor: 'Contractor',
            getSupport: 'Get support',
            terms: 'Terms and conditions',
            sitewideBanner: 'Site-wide banner',
            apiSettings: 'API settings',
            create: 'Create',
            exportTemplates: 'Export templates',
            reporting: 'Reporting',
            exportTemplateSummary: 'Export template summary',
            helpDrawerSetup: 'Help drawer setup',
            revisionReasonsAttributesSetup: 'Update reason setup',
            apiMappings: 'API mappings',
            manageMapping: 'Manage mapping',
            revisionReasonSetup: 'Update reason setup',
            landingSetup: 'Landing setup',
            acceptInvitation: 'Accept invitation',
            eula: 'End user license agreement',
            earlyAccess: 'Early access',
            checkEligible: 'See if you’re eligible',
          },
        },
        automatedCompliance: {
          baseMessage: `This field has Auto-Compliance capability`,
          defaultValueMessage: `Auto-Compliance found the default value to be "{{defaultValue}}".`,
          failedValueMessage: `Auto-Compliance was unable fill this field, please check with your local jurisdiction if this is required.`,
        },
        auditLog: {
          title: 'Audit Log',
          audit_log: 'Audit Log',
          export_csv: 'Export as .csv',

          // Table columns
          who: 'Who',
          action: 'Action',
          where: 'Where',
          details: 'Details',
          timestamp: 'Timestamp (PST)',

          // Filtering
          filter: 'Filter',
          filter_by_action: 'Filter by Action',
          filter_by_user: 'Filter by User',
          filter_by_table: 'Filter by Table',
          filter_by_date: 'Filter by Date',
          date_range: 'Date Range',
          clear_filters: 'Clear All Filters',
          all_actions: 'All actions',
          all_users: 'All users',
          all_tables: 'All tables',
          from_date: 'From date',
          to_date: 'To date',

          // Table name displays
          applications: 'applications',

          // Record operations (from backend translations)
          created_record: 'Record created',
          created_with_field: 'Created with {{field}}: {{value}}',
          updated_record: 'Record updated',
          changed_field: 'Changed {{field}} from {{from}} to {{to}}',
          deleted_record: 'Record deleted',
          removed_field: 'Removed {{field}}: {{value}}',

          // Login tracking
          user_logged_in: 'User logged in',
          login_from_ip: 'Login from IP: {{ip}}',
          login_count: 'Total logins: {{count}}',

          // UI messages
          total_items: '{{count}} total items',
          no_data: 'No audit logs found',
          unknown_user: 'Unknown User',
          unknown_email: 'Unknown email',
        },
        contractor: {
          contractorLabel: 'Contractor',
          fields: {
            contractorId: 'Contractor ID',
            primaryContactName: 'Primary contact name',
            primaryContactEmail: 'Primary contact email',
            doingBusinessAs: 'Doing business as',
            program: 'Program',
            lastUpdated: 'Last updated',
            dateSuspended: 'Date suspended',
            suspendedBy: 'Suspended by',
            dateRemoved: 'Date removed',
            removedBy: 'Removed by',
            noContact: 'No contact',
            noBusinessName: 'No business name',
            programPlaceholder: 'N/A',
          },
          submission: {
            ready: 'Ready to submit this {{submissionType}} form?',
            confirmation:
              'By submitting this {{submissionType}} form you confirm that the information you provided was completed to the best of your knowledge and ability.',
          },
          invoiceSuccess: {
            returnToDashboard: 'Return to dashboard',
            whatsNext: {
              heading: "What's next?",
              line1: 'You will receive an email confirming that your invoice was successfully submitted.',
              line2:
                'We randomly select some sites for inspection. If we select the site you worked at, we will let you know by email.',
              line3:
                "We will review your invoice and supporting information. If your invoice and supporting information are approved, we'll issue the rebate(s) through your selected payment method.",
            },
            needHelp: {
              heading: 'Need help?',
              message:
                'You can log into the Better Homes Energy Savings Program to view your submitted forms. Please contact <1>{{email}}</1> for questions related to your form.',
            },
          },
          management: {
            title: 'Manage contractor details',
            addButton: 'Add Contractor',
            searchPlaceholder: 'Search',
            tableHeading: 'Contractor accounts',
            confirmSuspend: 'Are you sure you want to suspend this contractor?',
            confirmDelete: 'Are you sure you want to remove this contractor?',
          },
          tabs: {
            active: 'Active',
            suspended: 'Suspended',
            removed: 'Removed',
          },
          actions: {
            manage: 'Manage',
            inviteEmployee: 'Invite employees',
            viewEmployees: 'View employees',
            viewContractor: 'View contractor',
            editContractor: 'Edit contractor',
            suspendContractor: 'Suspend contractor',
            unsuspendContractor: 'Unsuspend contractor',
            removeContractor: 'Remove contractor',
            viewStatusHistory: 'View status history',
          },
          statusHistory: {
            title: 'Status history',
            suspensionReasonsTitle: 'Suspension reasons',
            subtitle: 'Suspend, unsuspend, and removal history for {{name}}.',
            loading: 'Loading history...',
            empty: 'No status history yet.',
            error: 'Could not load status history. Please try again.',
            reasonLabel: 'Reason',
            byLabel: 'by',
            unknownActor: 'Unknown',
            close: 'Close',
            listLabel: 'Status change history',
            entryAria: '{{event}} by {{actor}} on {{date}}',
            entryAriaWithReason: '{{event}} by {{actor}} on {{date}}. Reason: {{reason}}',
            eventType: {
              suspend: 'Suspended',
              unsuspend: 'Unsuspended',
              remove: 'Removed',
            },
          },
          suspend: {
            modal: {
              title: 'Are you sure you want to suspend {{name}}?',
              message:
                "This will remove {{name}}'s access to the Energy Savings Program application system. All employees at {{name}} will not be able to upload invoices once suspended.",
            },
            reason: {
              title: 'Reason for suspension',
              label: 'Reason this contractor is suspended',
              placeholder: 'Enter suspension reason...',
              required: 'Reason is required',
              error: 'Failed to suspend contractor',
              success: 'Contractor suspended successfully',
            },
            confirmed: {
              title: 'Contractor suspended.',
              backButton: 'Back to Manage contractor details',
            },
          },
          unsuspend: {
            modal: {
              title: 'Are you sure you want to unsuspend {{name}}?',
              message:
                'This will give {{name}} access to the Energy Savings Program application system. All employees at {{name}} will be able to upload invoices once unsuspended.',
            },
            confirmed: {
              title: 'Contractor unsuspended',
            },
          },
          remove: {
            modal: {
              title: 'Are you sure you want to remove {{name}}?',
              message:
                'This will remove all employees of {{name}}. If they rejoin, contractors will have to onboard again and their employees will have to create accounts again.',
            },
            reason: {
              title: 'Reason for removal',
              label: 'Reason this contractor is being removed',
              placeholder: 'Enter removal reason...',
              required: 'Reason is required',
              error: 'Failed to remove contractor',
              success: 'Contractor removed successfully',
            },
            finalConfirm: {
              title: "This action can't be reversed, are you sure you want to continue?",
            },
            confirmed: {
              title: 'Contractor removed.',
              backButton: 'Back to Manage contractor details',
            },
          },
          suspended: {
            badge: 'Suspended',
            buttonDisabled: 'Submit invoice - disabled due to suspension',
            message: 'Your contractor account is suspended. You cannot submit invoices at this time.',
            banner: {
              title: 'Account suspended',
              message:
                'You can only view past submissions and access program resources. You can not submit a new invoice until we unsuspend your account.',
            },
            onboardingBanner: {
              title: 'Contractor suspended on {{date}}',
              viewReasons: 'View suspension reasons',
            },
          },
          employees: {
            viewEmployees: 'View employees',
            description:
              'Employee names and emails are associated with their Business BCeIDs. To update information, direct employees to manage their Business BCeID accounts.',
            loading: 'Loading employees',
            unknownEmployee: 'Unknown Employee',
            unknownContractor: 'Unknown Contractor',
            primaryContact: 'Primary contact',
            fields: {
              name: 'Name',
              email: 'Email address',
              lastUpdated: 'Last updated',
              action: 'Action',
            },
            tabs: {
              active: 'Active',
              pending: 'Pending',
              deactivated: 'Deactivated',
              ariaLabel: 'Employee status filter tabs',
              listAriaLabel: 'Select employee status to filter by',
            },
            actions: {
              setPrimaryContact: 'Primary contact',
              deactivateEmployee: 'Deactivate employee',
              reinviteEmployee: 'Re-invite employee',
              revokeEmployeeInvite: 'Revoke employee invite',
              reactivateEmployee: 'Reactivate employee',
              confirmDeactivateTitle: 'Are you sure you want to deactivate {{name}}?',
              confirmReactivateTitle: 'Are you sure you want to reactivate {{name}}?',
              confirmRevokeTitle: 'Are you sure you want to revoke this invite?',
              confirmReinviteTitle: 'Are you sure you want to re-invite\n{{name}}?',
              deactivateWarning:
                '{{name}} will not be able to access the application system until you reactivate them.',
              reactivateWarning:
                '{{name}} will be able to access the application system again when you reactivate their account.',
              revokeWarning: '{{name}} will no longer be able to create an account if you revoke this invite.',
              reinviteWarning: '{{name}} will receive another invite email when\nyou re-invite them.',
              primaryContactTitle: 'Are you sure you want {{name}} to be the primary contact?',
              primaryContactText: '{{name}} will receive the main communications for this company.',
            },
          },
          programResources: {
            title: 'Contractor program resources',
            pageHeading: 'Program resources: Program guidance',
            addEmployees: 'Add employees',
            checkEligibilityCode: 'Check eligibility code',
            checkEligibilityCode_description:
              "You can only receive payment for eligible work. Check your customer's eligibility code before providing a quote or starting any work. Each eligibility code can only be used for work completed at the approved address.",
            checkEligibilityCode_inputPlaceholder: 'Code e.g. ESP3-Dkecnc99hV02e99',
            checkEligibilityCode_search: 'Search',
            checkEligibilityCode_validWithExpiry: 'Valid until {{date}}',
            checkEligibilityCode_validExpired: 'Eligibility code expired on {{date}}',
            checkEligibilityCode_validNoExpiry: 'This code is valid',
            checkEligibilityCode_invalidFormat: 'Incorrect format ESP#-######',
            checkEligibilityCode_invalid: 'Invalid eligibility code',
            checkEligibilityCode_error: 'Could not check eligibility code. Please try again',
            programGuidance: 'Program guidance',
            qualifiedProductList: 'Qualified product list',
            sampleInvoices: 'Sample invoices',
            resourcesForCustomers: 'Resources for your customers',
            noResources: 'No resources available in this category.',
            resources: {
              createEmployeesAccounts: 'Step 1: Create employee accounts',
              formToAddEmployees: 'Step 2: Form to add employees',
              contractorRebateJourney: 'Contractor rebate journey',
              heatPumpExceptionForm: 'Heat pump exception form',
              heatPumpRequirements: 'Heat pump requirements guide',
              insulationCutSheet: 'Insulation cut sheet',
              windowsDoorsCutSheet: 'Windows and doors cut sheet',
              contractorTermsConditionsCondoApartment: 'Contractor terms and conditions - condos and apartments',
              contractorTermsConditionsgroundOriented: 'Contractor terms and conditions - ground oriented homes',
              participantTermsConditionsCondoApartment: 'Participant terms and conditions - condos and apartments',
              participantTermsConditionsgroundOriented: 'Participant terms and conditions - ground oriented homes',
              rebateEligibilityGroundOriented: 'Rebate eligibility requirements - ground oriented homes',
              rebateEligibilityCondoApartment: 'Rebate eligibility requirements - condos and apartments',
              heatPump: 'Heat pump',
              heatPumpWaterHeater: 'Heat pump water heater',
              heatPumpCondoApartment: 'Heat pump - condo and apartment',
              heatPumpWaterCondoApartment: 'Heat pump water heater - condo and apartment',
              windowsAndDoors: 'Windows and doors',
              insulation: 'Insulation',
              electricServiceUpgrade: 'Electric service upgrade',
              ventilation: 'Ventilation',
              healthAndSafety: 'Health & safety',
              participantInfoSheet: 'Participant info sheet',
              rebateEligibilityRequirements: 'Rebate eligibility requirements',
              participantTermsAndConditions: 'Participant terms and conditions',
              miniSplitHeatPumps: 'Mini-split, multi-split, central and dual fuel heat pumps list',
              airToWaterHeatPumps: 'Air-to-water heat pumps list',
              heatPumpWaterHeaterList: 'Heat pump water heater list',
              windowsAndDoorsList: 'Windows and doors list',
              ventilationList: 'Ventilation list',
              bathroomFanProductList: 'Bathroom fan product list',
            },
            descriptions: {
              createEmployeesAccounts: 'To create accounts for employees, login to the BCeID website.',
              miniSplitHeatPumps:
                'The installed heat pump must have an AHRI certified reference number and must be on the Qualifying Product List.',
              airToWaterHeatPumps:
                'For eligible air-to-water heat pumps and combination space and hot water air-to-water heat pumps, the heat pump must be on the product list.',
              heatPumpWaterHeaterList: 'The installed heater must be on Tier 2 or higher of the Eligible Models List.',
              windowsAndDoorsList:
                'The window-door must be listed with one of the following certification bodies: Canadian Standards Association, Intertek Canada, Labtest Certification, QAI Laboratories, National Fenestration Ratings Council.',
              ventilationList:
                "The installed heat-energy recovery ventilators must be ENERGY STAR® certified and listed on Natural Resources Canada's searchable product list.",
              bathroomFanProductList:
                "The installed bathroom fan must be ENERGY STAR certified and listed on the US Environmental Protection Agency and US Department of Energy's searchable product list.",
            },
            linkText: {
              qualifyingProductList: 'Qualifying Product List',
              productList: 'product list',
              eligibleModelsList: 'Eligible Models List',
              searchableProductList: 'searchable product list',
            },
            descriptionPart: {
              formToAddEmployees: [
                {
                  type: 'text',
                  content: 'Complete this form to allow your employees to log into the contractor portal. ',
                },
                {
                  type: 'bold',
                  content: ' You must use their Business BCeIDs ',
                },
                {
                  type: 'text',
                  content: ' when you complete the form.',
                },
              ],
            },
            fileInfoAirToWater: '. [124 KB, PDF]',
            fileInfoHPWH: '. [423 KB, PDF]',
            qualifiedProductListSubheading:
              'Installations must use items on the relevant qualified product list and/or be certified by the specified body to be eligible for ESP rebates.',
            addEmployeesSubheading:
              'You may want to grant your employees access to the contractor portal, so they can submit invoices and access program resources. To make this happen, employees need Business BCeID accounts, and you must complete the add employee form.',
            programResourcesPrefix: 'Program resources:',
          },
        },
        common: {
          search: 'Search',
        },
        shared: {
          actions: 'Actions',
          view: 'View',
          edit: 'Edit',
          delete: 'Delete',
        },
      },
    },
    // ... other languages
  },
  lng: 'en', // default language
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  parseMissingKeyHandler: (key, defaultValue) => {
    return fallbackTranslations.en.fallback;
  },
};

i18n.use(initReactI18next).init(options);

export type TTranslationResources = (typeof options)['resources'];

export default i18n;
